// src/pages/Landing.jsx
import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { Link } from "react-router-dom";
import videoAdShowcase1 from "../assets/Video ad 1.png";
import videoAdShowcase2 from "../assets/Video ad 2.png";
import videoAdShowcase3 from "../assets/Video ad 3.png";
import videoAdShowcase4 from "../assets/Video ad 4.png";
import videoAdExplanation from "../assets/video ad explanation.mp4";
import {
  Check,
  Star,
  ChevronDown,
  ChevronUp,
  Crown,
  Zap,
  Image as ImageIcon,
  Film,
  Link as LinkIcon,
  ExternalLink,
} from "lucide-react";
// Cloudinary landing media
const loginAvatar = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302059/login-avatar_yyq8rp.png";
const placeholderImage = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302054/placeholder_cfdnhq.jpg";

const trustpilotLogo = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302058/trustpilot-logo_zenfb9.svg";

// Social-proof avatars (used in hero love pill)
const avatar1 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302044/avatar-1_or1dht.jpg";
const avatar2 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302044/avatar-2_gbaskl.jpg";
const avatar3 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302044/avatar-3_ga8w17.jpg";
const avatar4 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302044/avatar-4_nhk12x.jpg";
// Reviews avatars (24 total)
const avatar5 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302044/avatar-5_clacby.jpg";
const avatar6 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302044/avatar-6_aa9mqy.jpg";
const avatar7 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302045/avatar-7_ztb8qd.jpg";
const avatar8 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302045/avatar-8_r5l89w.jpg";
const avatar9 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302046/avatar-9_biu9gc.jpg";
const avatar10 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302046/avatar-10_mm9g3p.jpg";
const avatar11 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302046/avatar-11_m7p2c3.jpg";
const avatar12 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302046/avatar-12_v17eas.jpg";
const avatar13 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302047/avatar-13_dt2k4g.jpg";
const avatar14 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302047/avatar-14_oe07mq.jpg";
const avatar15 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302048/avatar-15_uaqvce.jpg";
const avatar16 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302048/avatar-16_f9xgcd.jpg";
const avatar17 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302048/avatar-17_vlqo86.jpg";
const avatar18 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302049/avatar-18_zgyfcy.jpg";
const avatar19 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302050/avatar-19_nef28o.jpg";
const avatar20 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302050/avatar-20_upmqlv.jpg";
const avatar21 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302050/avatar-21_q8epjg.jpg";
const avatar22 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302050/avatar-22_a3ciq7.jpg";
const avatar23 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302051/avatar-23_dkvnax.jpg";
const avatar24 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302051/avatar-24_hpmh53.jpg";

// Partner logos (use ONLY these in carousel)
const partnerLogo1 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302052/partnerLogo1_o7m2aw.svg";
const partnerLogo2 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302053/partnerLogo2_u1llgh.svg";
const partnerLogo3 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302053/partnerLogo3_z5sntw.svg";
const partnerLogo6 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302053/partnerLogo6_zzsnui.svg";

// Real outputs showcase images restored from Landing 2
const rotating1 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302054/Rotating_1-min_vka4lc.png";
const rotating2 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302054/Rotating_2-min_gjhsfx.png";
const rotating3 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302054/Rotating_3-min_wnixtt.png";
const rotating4 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302055/Rotating_4-min_trvsqq.png";
const rotating5 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302056/Rotating_5-min_c9q77r.png";
const rotating6 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302056/Rotating_6-min_ndajnp.png";
const rotating7 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302056/Rotating_7-min_fkpt17.png";
const rotating8 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302056/Rotating_8-min_s9mrw4.png";
const rotating9 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302057/Rotating_9-min_b6oqc2.png";
const rotating10 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302057/Rotating_10-min_ltnqqh.png";
const rotating11 = "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302058/Rotating_11-min_bhvcgu.png";

const ACCENT = "#F82E88";
const GREEN = "#22c55e";
const BORDER = "#2A2A40";

const PAGE_GRADIENT =
  "radial-gradient(circle at top, #26266b 0, #050514 55%, #000 100%)";

/* -------------------- Public API base (Landing is unauthenticated) --------
   ✅ Landing serves unauthenticated users.
   It must call ONLY public endpoints (no Clerk token) and still reflect
   backoffice changes from admin_settings.
------------------------------------------------------------------------- */
const API_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" && window._API_BASE) ||
  "https://ecom-ads-ai-production.up.railway.app";

/* -------------------- Promo defaults + tiny sanitizers -------------------- */
const DEFAULT_PROMO = {
  enabled: true,
  headline: "Try PixelAds.ai 100% free",
  subtext: "No credit card required!",
  links: [], // [{ label, href, newTab }]
};

function asString(v, fallback = "") {
  if (v === null || v === undefined) return fallback;
  return String(v).trim();
}

/**
 * ✅ ESLint fix (no-script-url):
 * CRA’s eslint rule flags *any* literal that matches a script URL prefix.
 * So we avoid writing that prefix as a literal in source code.
 */
const JS_URL_PREFIX = String.fromCharCode(
  106, 97, 118, 97, 115, 99, 114, 105, 112, 116, 58
); // "javascript:"
const DATA_URL_PREFIX = String.fromCharCode(100, 97, 116, 97, 58); // "data:"

function useLoginAvatarFallback(e) {
  if (!e?.currentTarget) return;
  e.currentTarget.onerror = null;
  e.currentTarget.src = loginAvatar;
}

function isSafeHref(href) {
  const h = asString(href, "");
  if (!h) return false;

  const lower = h.toLowerCase();

  // Reject script/data URLs
  if (lower.startsWith(JS_URL_PREFIX) || lower.startsWith(DATA_URL_PREFIX)) {
    return false;
  }

  if (lower.startsWith("http://") || lower.startsWith("https://")) return true;
  if (lower.startsWith("/")) return true;
  if (lower.startsWith("#")) return true;
  if (lower.startsWith("mailto:")) return true;

  return false;
}

function sanitizeLinks(links) {
  if (!Array.isArray(links)) return [];
  const out = [];

  for (const raw of links) {
    const label = asString(raw?.label, "").slice(0, 48);
    const href = asString(raw?.href, "").slice(0, 500);
    const newTab = !!raw?.newTab;

    if (!label || !isSafeHref(href)) continue;

    out.push({ label, href, newTab });
    if (out.length >= 5) break;
  }

  return out;
}

function sanitizePromo(input) {
  const enabled =
    typeof input?.enabled === "boolean" ? input.enabled : DEFAULT_PROMO.enabled;

  const hasHeadline =
    input && Object.prototype.hasOwnProperty.call(input, "headline");
  const hasSubtext =
    input && Object.prototype.hasOwnProperty.call(input, "subtext");

  const headline = (hasHeadline
    ? asString(input?.headline, "")
    : asString(DEFAULT_PROMO.headline, "")
  ).slice(0, 120);

  const subtext = (hasSubtext
    ? asString(input?.subtext, "")
    : asString(DEFAULT_PROMO.subtext, "")
  ).slice(0, 200);

  const links = sanitizeLinks(input?.links);

  return { enabled, headline, subtext, links };
}

/* -------------------- ✅ Starter bundle (signup bonus) -------------------- */
const DEFAULT_SIGNUP_BONUS = { images: 5, videos: 1, urls: 1 };

function normalizeSignupBonus(raw) {
  const images = Number.isFinite(+raw?.images)
    ? Math.max(0, Math.floor(+raw.images))
    : 0;
  const videos = Number.isFinite(+raw?.videos)
    ? Math.max(0, Math.floor(+raw.videos))
    : 0;
  const urls = Number.isFinite(+raw?.urls)
    ? Math.max(0, Math.floor(+raw.urls))
    : 0;

  // If backend returns empty/zeros, keep defaults instead of showing zeros
  if (images === 0 && videos === 0 && urls === 0) return DEFAULT_SIGNUP_BONUS;

  return { images, videos, urls };
}

/* -------------------- Pricing helpers (match Pricing.jsx logic) ----------- */
const euro2 = (n) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

const parseEuroFromLabel = (label) => {
  if (!label) return null;
  const m = String(label).match(/€\s*([\d.,]+)/);
  if (!m) return null;
  const s = m[1].trim();

  // If both '.' and ',' → European: '.' thousands, ',' decimals
  if (s.includes(".") && s.includes(",")) {
    return Number.parseFloat(s.replace(/\./g, "").replace(",", "."));
  }
  // Only comma → decimal separator
  if (s.includes(",")) return Number.parseFloat(s.replace(",", "."));
  return Number.parseFloat(s);
};

const pickFirst = (...vals) => {
  for (const v of vals) if (v !== undefined && v !== null) return v;
  return null;
};

const upliftMonthlyAnchor = (priceLike, uplift = 0.3) => {
  const value =
    typeof priceLike === "number" && Number.isFinite(priceLike)
      ? priceLike
      : parseEuroFromLabel(priceLike);

  if (!Number.isFinite(value) || value <= 0) return "";
  return euro2(value * (1 + uplift));
};

const DAILY_DEAL_MS = 24 * 60 * 60 * 1000;
const DAILY_DEAL_STORAGE_KEY = "pixelads.dailyDeal.endsAt";
const LANDING_CACHE_RESET_VERSION = "2026-05-24-landing-cta-cards-v1";
const LANDING_CACHE_RELOAD_KEY = `pixelads.cacheReset.${LANDING_CACHE_RESET_VERSION}`;

async function clearStaleClientCaches() {
  if (typeof window === "undefined") return;

  let removedStaleCache = false;

  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      const unregistered = await Promise.all(
        registrations.map((registration) => registration.unregister())
      );
      removedStaleCache =
        unregistered.some((wasRemoved) => wasRemoved) || removedStaleCache;
    }

    if ("caches" in window) {
      const cacheNames = await window.caches.keys();
      const deleted = await Promise.all(
        cacheNames.map((cacheName) => window.caches.delete(cacheName))
      );
      removedStaleCache =
        deleted.some((wasDeleted) => wasDeleted) || removedStaleCache;
    }

    if (
      removedStaleCache &&
      !window.sessionStorage.getItem(LANDING_CACHE_RELOAD_KEY)
    ) {
      window.sessionStorage.setItem(LANDING_CACHE_RELOAD_KEY, "1");
      window.location.reload();
    }
  } catch (_e) {
    // Cache removal must never prevent the public landing page from rendering.
  }
}

function resolveNextDailyDealEndsAt() {
  const fallback = Date.now() + DAILY_DEAL_MS;

  if (typeof window === "undefined") return fallback;

  try {
    const stored = Number(window.localStorage.getItem(DAILY_DEAL_STORAGE_KEY));
    if (Number.isFinite(stored) && stored > Date.now()) return stored;

    const next = Date.now() + DAILY_DEAL_MS;
    window.localStorage.setItem(DAILY_DEAL_STORAGE_KEY, String(next));
    return next;
  } catch (_e) {
    return fallback;
  }
}

function rolloverDailyDealEndsAt() {
  const next = Date.now() + DAILY_DEAL_MS;

  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(DAILY_DEAL_STORAGE_KEY, String(next));
    } catch (_e) {
      // ignore storage failures
    }
  }

  return next;
}

function getCountdownParts(msLeft) {
  const safe = Math.max(0, Math.floor(msLeft / 1000));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;

  return {
    hours: String(hours).padStart(2, "0"),
    minutes: String(minutes).padStart(2, "0"),
    seconds: String(seconds).padStart(2, "0"),
  };
}

function extractSignupBonusFromPlansPayload(plansData) {
  const caps =
    plansData?.caps ||
    plansData?.tier_caps ||
    plansData?.tierCaps ||
    plansData?.tiercaps ||
    plansData?.config ||
    plansData?.pricing ||
    plansData?.data?.caps ||
    plansData?.data?.tier_caps ||
    plansData?.data?.tierCaps ||
    plansData?.data?.tiercaps ||
    plansData?.data?.config ||
    plansData?.data?.pricing ||
    null;

  const sbRaw = pickFirst(
    // direct (common)
    plansData?.signupBonus,
    plansData?.signup_bonus,
    plansData?.data?.signupBonus,
    plansData?.data?.signup_bonus,

    // wrappers
    caps?.signupBonus,
    caps?.signup_bonus,

    // aliases used in backoffice / older code
    caps?.trial_bonus,
    caps?.trial_offer,
    caps?.trial_offer_bonus,
    caps?.free_trial_bonus,
    caps?.free_trial_offer,
    caps?.signup_addons,
    caps?.signup_addons_bonus,
    caps?.signup_bundle,
    caps?.starter_bundle,
    caps?.starter_bonus,
    caps?.free_addons_signup,
    caps?.free_addons_on_signup,

    // sometimes nested under "tier_caps" itself
    plansData?.tier_caps?.signup_bonus,
    plansData?.tierCaps?.signup_bonus,
    plansData?.caps?.signup_bonus,

    // sometimes nested under pricing/config objects
    plansData?.pricing?.signup_bonus,
    plansData?.config?.signup_bonus,

    DEFAULT_SIGNUP_BONUS
  );

  return normalizeSignupBonus(sbRaw || {});
}

const capInt = (v, fallback = 0) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return fallback;
  return Math.max(0, Math.floor(n));
};

function toLandingPlanView(rawPlan) {
  const m = Number(rawPlan?.priceEurMonthly);
  const y = Number(rawPlan?.priceEurYearly);

  const monthlyOk = Number.isFinite(m) && m > 0;
  const yearlyOk = Number.isFinite(y) && y > 0;

  const monthlyPrice = monthlyOk
    ? euro2(m)
    : asString(rawPlan?.monthlyPrice, "€0.00");
  const yearlyPricePerMonth = yearlyOk
    ? euro2(y / 12)
    : asString(rawPlan?.yearlyPricePerMonth, "€0.00");
  const yearlyBilled = yearlyOk
    ? `${euro2(y)} billed annually`
    : asString(rawPlan?.yearlyBilled, "");

  return {
    id: asString(rawPlan?.id, ""),
    name: asString(rawPlan?.name, ""),
    monthlyPrice,
    yearlyPricePerMonth,
    yearlyBilled,
    imagesPerMonth: capInt(rawPlan?.imagesCap ?? rawPlan?.imagesPerMonth, 0),
    videosPerMonth: capInt(rawPlan?.videosCap ?? rawPlan?.videosPerMonth, 0),
    pagesPerMonth: capInt(rawPlan?.analyzeCap ?? rawPlan?.pagesPerMonth, 0),
    mostUsed:
      Boolean(rawPlan?.mostUsed) ||
      String(rawPlan?.id || "").toLowerCase() === "pro",
  };
}

/* -------------------- Fallback Landing pricing (used only if API fails) --- */
const FALLBACK_PLANS_RAW = [
  {
    id: "starter",
    name: "Starter",
    priceEurMonthly: 19.99,
    priceEurYearly: 199.9,
    imagesCap: 20,
    videosCap: 4,
    analyzeCap: 10,
  },
  {
    id: "pro",
    name: "Pro",
    priceEurMonthly: 39.99,
    priceEurYearly: 399.9,
    imagesCap: 70,
    videosCap: 10,
    analyzeCap: 30,
    mostUsed: true,
  },
  {
    id: "business",
    name: "Business",
    priceEurMonthly: 59.99,
    priceEurYearly: 599.9,
    imagesCap: 200,
    videosCap: 22,
    analyzeCap: 80,
  },
];

const FALLBACK_LANDING_PLANS_VIEW = FALLBACK_PLANS_RAW.map(toLandingPlanView);

/* -------------------- "Everything in every plan" feature list (3 columns) */
const EVERYTHING_PLAN_COLUMNS = [
  [
    "AI UGC-style testimonial video ads",
    "Product-holding AI avatar videos",
    "Product spotlight and demo videos",
    "Problem / solution video scripts",
    "Product or service explainers",
    "Voiceovers and subtitles",
  ],
  [
    "Product URL analysis",
    "Ad-ready social video formats",
    "Product avatar images",
    "AI product photoshoots",
    "Ad creative images",
    "9:16, 4:5, 16:9, 1:1 aspect ratios",
  ],
  [
    "Remove image background",
    "Extend (outpaint)",
    "Object remover",
    "Object replacer",
    "Enhancer and upscaler",
    "Light and colour fixes",
  ],
];

/* -------------------- Media map: reuse Generate page GIFs/videos --------- */
const FEATURE_MEDIA = {
  // Ads
  productAvatarVideo: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302083/product-avatar-video_jiydsy.mp4" },
  adMarketingVideo: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302086/avatar-explainer-video_kogj1y.mp4" },
  productAvatarImage: {
    type: "image",
    src: "https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302082/product-avatar-image_asokgi.webp",
  },
  photoshootAnyshoot: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302084/product-photoshoot_wdnnin.mp4" },
  photoshoot: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302084/product-background-changer_kgvyzj.mp4" },
  adCreatives: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302076/ad-creative-image_vpwgtu.mp4" },

  // Improvements
  removeBackground: {
    type: "video",
    src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302085/remove-image-background_sramkd.mp4",
  },
  colorRestoration: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302075/color-restoration_wxbtzj.mp4" },
  enhancer: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302076/enhancer_retqbw.mp4" },
  outpaint: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302076/extend-image-outpaint_d7lfvo.mp4" },
  lightFix: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302077/light-fix_gn90ug.mp4" },
  objectReplacer: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302082/object-replacer_emng9o.mp4" },
  objectRemover: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302081/object-remover_ufuo9p.mp4" },
  oldPhotosRestoration: {
    type: "video",
    src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302082/old-photos-restoration_o3niaz.mp4",
  },
  upscaler: { type: "video", src: "https://res.cloudinary.com/dxggxu3qn/video/upload/v1779302085/upscaler_e4evbc.mp4" },
};

/* -------------------- Core features (header dropdown + feature blocks) ---- */
const FEATURES = [
  // VIDEO ADS — primary value proposition
  {
    id: "feature-ugc-video",
    emoji: "🎬",
    title: "AI UGC-style testimonial ads",
    description:
      "Create creator-style product reviews with a lifelike AI avatar, sales script, voiceover, and subtitles.",
    mediaKey: "adMarketingVideo",
    category: "Video ads",
    details:
      "UGC means user-generated content: the native-feeling videos where a creator talks about a product, demonstrates it, or shares a recommendation. PixelAds lets you create this ad style using AI avatars and your product content — without waiting for influencer footage, filming days, or manual video editing.",
    bullets: [
      "Turn a product URL or product brief into review-style, testimonial, or unboxing-style video concepts.",
      "Generate scripts around your benefits, objections, promotion, and call to action.",
      "Choose an AI avatar and voice to present your offer in a familiar social-feed format.",
      "Add subtitles for TikTok, Reels, Meta and Shorts viewers watching without sound.",
    ],
  },
  {
    id: "feature-product-avatar-video",
    emoji: "🧍‍♂️",
    title: "Product-holding AI avatar videos",
    description:
      "Let a realistic AI presenter hold, point to, and demonstrate your actual product on camera.",
    mediaKey: "productAvatarVideo",
    category: "Video ads",
    details:
      "Start from a clear product image or product page and generate an in-hand presenter video. Your product is no longer limited to static photos: an AI avatar can showcase it naturally, explain why it matters, and bring a human face to paid ads and product pages.",
    bullets: [
      "Generate product-in-hand visuals without shipping samples to creators or organising a shoot.",
      "Show product size, usage context, key features, and offer messaging in a human format.",
      "Ideal for Shopify products, dropshipping tests, marketplace listings, and launch ads.",
      "Create multiple avatar and script variations for different customer angles.",
    ],
  },

  // IMAGE ADS
  {
    id: "feature-product-avatar-image",
    emoji: "🧑‍🎨",
    title: "Product avatar images",
    description:
      "Create hyper-realistic images of AI avatars with your product for feeds, thumbnails, and banners.",
    mediaKey: "productAvatarImage",
    category: "Image ads",
    details:
      "Get scroll-stopping product + avatar shots without booking a photoshoot. Use them in PDP galleries, email banners, ad creatives, and social posts to show your product ‘in use’ in a human way.",
    bullets: [
      "Combine your product image with AI avatars in realistic poses and scenes.",
      "Generate multiple crops and ratios for PDPs, carousels, and hero banners.",
      "Test different persona types (creator, expert, everyday consumer) quickly.",
    ],
  },
  {
    id: "feature-photoshoot",
    emoji: "✨",
    title: "Product photoshoots",
    description:
      "Drop your product into AI-generated studio scenes and lifestyle settings in multiple ratios.",
    mediaKey: "photoshootAnyshoot",
    category: "Image ads",
    details:
      "Simulate a full product photoshoot from a single image. Place your product into realistic lifestyle scenes, tabletops, and studio setups that look like a brand shoot, not a stock photo.",
    bullets: [
      "Upload a packshot or cutout, then let the AI create lifestyle and studio scenes.",
      "Generate multiple compositions for different audiences and ad angles.",
      "Produce Story, feed, and website-ready shots in one flow.",
    ],
  },
  {
    id: "feature-background-changer",
    emoji: "🌅",
    title: "Background changer",
    description:
      "Instantly replace backgrounds with on-brand scenes, from lifestyle setups to flat-lay visuals.",
    mediaKey: "photoshoot",
    category: "Image ads",
    details:
      "Swap boring or messy backgrounds for clean, on-brand scenes in seconds. Perfect when you already have product shots but want more polished, consistent visuals across your store and ads.",
    bullets: [
      "Remove the original background and place products on solid colors, gradients, or branded backdrops.",
      "Create lifestyle scenes that match your brand (kitchen table, bathroom shelf, desk setup, etc.).",
      "Keep lighting, shadows, and reflections natural so edits don’t look fake.",
    ],
  },
  {
    id: "feature-ad-creatives",
    emoji: "📣",
    title: "Ad creative images",
    description:
      "Turn your analyzed product into Canva-style ads with overlays, copy, and promo badges.",
    mediaKey: "adCreatives",
    category: "Image ads",
    details:
      "Go from plain product images to fully designed ad creatives. Add headlines, price tags, discount badges, and CTAs in layouts tuned for performance marketing.",
    bullets: [
      "Start from templates designed for feed, Story, and display placements.",
      "Overlay brand colors, logos, and promo badges in a few clicks.",
      "Generate multiple variants for different audiences, offers, and pain points.",
    ],
  },

  // IMAGE CLEANUP & FIXES
  {
    id: "feature-remove-bg",
    emoji: "🎯",
    title: "Remove image background",
    description:
      "Create clean PNG cutouts with transparent backgrounds for catalogs, PDPs, and retargeting ads.",
    mediaKey: "removeBackground",
    category: "Image cleanup & fixes",
    details:
      "Turn any product shot into a clean, transparent PNG in seconds. Ideal for catalogs, comparison images, and retargeting ads where you want the product to be the hero.",
    bullets: [
      "Remove busy or off-brand backgrounds automatically, no manual masking.",
      "Export transparent PNGs that drop neatly into any creative or landing page.",
      "Keep edges clean so products look sharp on light, dark, or gradient backgrounds.",
    ],
  },
  {
    id: "feature-color-restoration",
    emoji: "🎨",
    title: "Color restoration",
    description:
      "Fix faded, dull or incorrect colors while keeping products looking natural.",
    mediaKey: "colorRestoration",
    category: "Image cleanup & fixes",
    details:
      "Quickly repair white-balance issues or inconsistent color across different shoots. Ideal when your product looks too warm, too cold, or simply off-brand.",
    bullets: [
      "Restore natural-looking colors without over-saturating your images.",
      "Correct white balance so whites look neutral across all creatives.",
      "Make older or user-generated photos match your current brand look.",
    ],
  },
  {
    id: "feature-enhancer",
    emoji: "🪄",
    title: "Enhancer",
    description:
      "Improve clarity and detail – sharpen, reduce noise, and boost overall image quality.",
    mediaKey: "enhancer",
    category: "Image cleanup & fixes",
    details:
      "Rescue borderline-quality assets so they’re safe to use in ads. Sharpen, denoise and clean up images so they still look good on high-density mobile and desktop displays.",
    bullets: [
      "Reduce noise and grain in low-light or older photos.",
      "Sharpen soft details so products look crisp and defined.",
      "Make borderline assets usable again in performance creatives.",
    ],
  },
  {
    id: "feature-outpaint",
    emoji: "🖼️",
    title: "Extend image (Outpaint)",
    description:
      "Extend your image beyond its borders to wider or taller compositions without cropping.",
    mediaKey: "outpaint",
    category: "Image cleanup & fixes",
    details:
      "Turn tight product photos into Story, feed, or banner-ready layouts by extending the scene. Keep the original framing, just add more room for copy and design.",
    bullets: [
      "Extend images horizontally or vertically for new formats.",
      "Keep style, lighting, and texture consistent across the extended areas.",
      "Create space for headlines, prices, and CTAs without hiding the product.",
    ],
  },
  {
    id: "feature-light-fix",
    emoji: "☀️",
    title: "Light fix",
    description:
      "Correct exposure and lighting issues for balanced highlights, shadows, and midtones.",
    mediaKey: "lightFix",
    category: "Image cleanup & fixes",
    details:
      "Fix underexposed or overexposed shots in one click. Rebalance highlights, shadows and contrast so every image looks like it was shot in ideal conditions.",
    bullets: [
      "Brighten dark images without blowing out highlights.",
      "Recover detail in shadows and midtones.",
      "Make lighting look consistent across different shoots and creatives.",
    ],
  },
  {
    id: "feature-object-replacer",
    emoji: "🧩",
    title: "Object replacer",
    description:
      "Paint a mask to swap objects while keeping lighting, shadows, and texture consistent.",
    mediaKey: "objectReplacer",
    category: "Image cleanup & fixes",
    details:
      "Fix or reimagine your images without reshooting. Swap props, update product variants, or adjust labels while keeping the original scene realistic.",
    bullets: [
      "Brush over anything you want to replace – from mugs to labels and props.",
      "Describe what should appear instead (e.g. ‘replace mug with iced latte’).",
      "Generate variations while preserving original lighting and perspective.",
    ],
  },
  {
    id: "feature-object-remover",
    emoji: "🧹",
    title: "Object remover",
    description:
      "Paint a mask over unwanted areas and remove objects cleanly while preserving the background.",
    mediaKey: "objectRemover",
    category: "Image cleanup & fixes",
    details:
      "Remove distractions like extra products, hands, or clutter so the main item stands out. Perfect when you like the shot but not everything inside it.",
    bullets: [
      "Paint over logos, clutter or unwanted objects in seconds.",
      "Let AI reconstruct the background behind removed elements.",
      "Clean up PDP and ad images without starting from scratch.",
    ],
  },
  {
    id: "feature-old-photos",
    emoji: "📷",
    title: "Old photo restoration",
    description:
      "Repair scratches, noise, and color fade in older or low-quality photos to reuse them in ads.",
    mediaKey: "oldPhotosRestoration",
    category: "Image cleanup & fixes",
    details:
      "Bring older brand photography or UGC back to life instead of re-shooting everything. Repair scratches, restore faded colors, and remove artifacts so old assets are usable again.",
    bullets: [
      "Restore damaged or faded photos so they match your current creative quality.",
      "Fix grain, scratches, and discoloration automatically.",
      "Reuse legacy assets in modern campaigns without a new shoot.",
    ],
  },
  {
    id: "feature-upscaler",
    emoji: "📶",
    title: "Upscaler",
    description:
      "Increase image resolution while preserving sharpness and detail with AI super-resolution.",
    mediaKey: "upscaler",
    category: "Image cleanup & fixes",
    details:
      "Turn small or low-res assets into high-resolution images that still look sharp. Great for repurposing old creatives or UGC into larger formats.",
    bullets: [
      "Upscale images so they stay crisp on high-resolution displays.",
      "Avoid pixelation when you need bigger crops or new aspect ratios.",
      "Prepare assets for 4:5, 9:16 and 16:9 placements without quality loss.",
    ],
  },
];

// Category order for the big Features section
const FEATURE_CATEGORIES = ["Video ads", "Image ads", "Image cleanup & fixes"];

const REAL_OUTPUT_ITEMS = [
  { src: rotating1, title: "Background removal" },
  { src: rotating2, title: "Background changer" },
  { src: rotating3, title: "Object remover" },
  { src: rotating4, title: "Old photos restore" },
  { src: rotating5, title: "Product photoshoot" },
  { src: rotating6, title: "Object replacer" },
  { src: rotating7, title: "Light fix" },
  { src: rotating8, title: "Upscaler" },
  { src: rotating9, title: "Enhancer" },
  { src: rotating10, title: "Background removal" },
  { src: rotating11, title: "Extender" },
];


// ✅ Large “aiapply-style” grid (placeholder icon, > 20 cards)
const AIAPPLY_STYLE_REVIEWS = [
  {
    name: "Darius",
    role: "Shopify Founder",
    avatar: avatar1,
    quote:
      "We went from “we need creatives” to live ads the same day. That never happened before.",
  },
  {
    name: "Luca",
    role: "Meta Ads Buyer",
    avatar: avatar2,
    quote:
      "The biggest win is speed. I can spin 6–10 variations, kill losers fast, and keep the account clean.",
  },
  {
    name: "Hana",
    role: "Ecommerce Manager",
    avatar: avatar3,
    quote:
      "The outputs look consistent across products — backgrounds, lighting, and crop formats. It keeps the store looking premium.",
  },
  {
    name: "Matea",
    role: "Agency Owner",
    avatar: avatar4,
    quote:
      "We ship more concepts per client without adding headcount. It’s basically a creative multiplier.",
  },
  {
    name: "Noel",
    role: "DTC Marketer",
    avatar: avatar5,
    quote:
      "Photoshoots + ad creatives is the combo. I don’t have to bounce between 3 tools anymore.",
  },
  {
    name: "Theo",
    role: "Growth Lead",
    avatar: avatar6,
    quote: "Analyze once, reuse everywhere. That workflow alone is worth it for us.",
  },
  {
    name: "Andrei",
    role: "Paid Social Specialist",
    avatar: avatar7,
    quote:
      "Vertical videos with captions ready to go is huge. We launch faster and the edits are minimal.",
  },
  {
    name: "Roxana",
    role: "Brand Owner",
    avatar: avatar8,
    quote:
      "We used to wait on freelancers. Now we publish new angles weekly — sometimes daily during promos.",
  },
  {
    name: "Sana",
    role: "Marketplace Seller",
    avatar: avatar9,
    quote:
      "Background removal + cleanup made our listings look instantly more legit. Simple, but it moved the needle.",
  },
  {
    name: "Victoria",
    role: "Creative Strategist",
    avatar: avatar10,
    quote:
      "It’s easy to iterate hooks and offers without rebuilding the whole creative. Testing feels frictionless now.",
  },
  {
    name: "Iris",
    role: "Ecommerce Operator",
    avatar: avatar11,
    quote:
      "Our PDP images look cleaner and we reuse them in ads without extra work. That consistency matters.",
  },
  {
    name: "Jonas",
    role: "Media Buyer",
    avatar: avatar12,
    quote:
      "A/B testing became straightforward. More shots, more angles, better decisions.",
  },
  {
    name: "Maya",
    role: "Performance Marketer",
    avatar: avatar13,
    quote:
      "The templates aren’t gimmicky — they’re practical. I can ship a solid creative in minutes.",
  },
  {
    name: "Olivia",
    role: "Shopify Store Owner",
    avatar: avatar14,
    quote:
      "We finally have consistent creatives across products and campaigns. It just looks like one brand.",
  },
  {
    name: "Klaus",
    role: "DTC Founder",
    avatar: avatar15,
    quote:
      "Short version: it saves time. Long version: it saves time every single week, and I’m less stressed.",
  },
  {
    name: "Eva",
    role: "Agency Strategist",
    avatar: avatar16,
    quote:
      "We use PixelAds for rapid concept testing, then scale what works. It’s perfect for early validation.",
  },
  {
    name: "Giulio",
    role: "Ecommerce Marketer",
    avatar: avatar17,
    quote:
      "The cleanup tools rescued old assets we thought were unusable. That’s money saved on reshoots.",
  },
  {
    name: "Denis",
    role: "Paid Social Lead",
    avatar: avatar18,
    quote:
      "The outputs are consistent across ratios. 9:16, 4:5, 1:1 — no weird crops or surprises.",
  },
  {
    name: "Kamal",
    role: "Amazon Seller",
    avatar: avatar19,
    quote:
      "Same product, better presentation. Cleaner visuals and faster video testing made our campaigns much easier to optimize.",
  },
  {
    name: "Sara",
    role: "Creative Ops",
    avatar: avatar20,
    quote:
      "It keeps our workflow organized. Less chaos, fewer files, and everyone uses the same source assets.",
  },
  {
    name: "Maria",
    role: "Brand Manager",
    avatar: avatar21,
    quote:
      "Reliable output. We can keep campaigns fresh without burning out the team.",
  },
  {
    name: "Leo",
    role: "Ecommerce Manager",
    avatar: avatar22,
    quote:
      "Great for seasonal refreshes. We updated visuals across the catalog in a weekend.",
  },
  {
    name: "Noah",
    role: "Growth Marketer",
    avatar: avatar23,
    quote: "Ad-ready output. Less tweaking, more launching.",
  },
  {
    name: "Bastian",
    role: "Shopify Founder",
    avatar: avatar24,
    quote:
      "If you run offers often, this is a no-brainer. We can produce variants for every promo fast.",
  },
];

/* -------------------- FAQ data ------------------------------------------- */
const FAQ_ITEMS = [
  {
    q: "What is a UGC-style video ad?",
    a: "UGC means user-generated content: the creator-style videos shoppers see in TikTok, Reels, and Meta ads, such as a product review, testimonial, demonstration, or recommendation. PixelAds creates this familiar ad format using AI avatars, voiceovers, and subtitles.",
  },
  {
    q: "Can an AI avatar hold and present my actual product?",
    a: "Yes. Start with a clear product image or product page and generate an in-hand product avatar video where a lifelike presenter holds or showcases the item. This is useful for product demos, social ad variations, and product-page content.",
  },
  {
    q: "Do I need to ship products to creators or film anything?",
    a: "No. You can start with a product URL or product images and build AI avatar-led UGC-style videos without hiring talent, coordinating shoot days, or shipping samples to influencers.",
  },
  {
    q: "Which ecommerce video ad formats can I create?",
    a: "Create Product Spotlight, Problem / Solution, AI UGC Testimonial, How-To / Demo, product-holding avatar, promotion or sale, and explainer-style video concepts. Use different hooks and scripts to test which angle works best for your offer.",
  },
  {
    q: "Can I generate an explainer video for an app or service?",
    a: "Yes. PixelAds can turn service or app information into an avatar-led marketing script and subtitle-ready explainer video that communicates the problem, benefit, offer, and call to action.",
  },
  {
    q: "Where can I use the videos?",
    a: "Generate videos for TikTok and Instagram Reels in vertical format, Meta feeds and carousels, YouTube Shorts, product pages, landing pages, and organic social content. Choose the aspect ratio that fits your placement.",
  },
  {
    q: "What do I need to create my first video?",
    a: "Start with a product or service page URL, or upload clear product images. PixelAds uses your content and visuals to help create scripts, avatar videos, product-holding scenes, and supporting ad creatives.",
  },
  {
    q: "Do I need a credit card to start?",
    a: "No. You can create an account and try PixelAds without adding a credit card. Upgrade only when you are ready to generate more content.",
  },
]

// High-converting examples displayed as full sections directly under the hero.
const VIDEO_AD_SHOWCASE_SLIDES = [
  {
    src: videoAdShowcase1,
    label: "Product URL → complete ad kit",
    title: "Turn one product link into ads and videos built to sell",
    text: "Paste your product page and let PixelAds create clear visual angles plus a creator-style video that gets the product benefit across instantly.",
    bullets: [
      "Extracts product details and key selling points from your URL",
      "Creates image ads and video concepts from the same product",
      "Gives you more creatives to launch and test faster",
    ],
    tags: ["Product URL", "Ad images", "AI videos"],
    cta: "Turn my product into ads",
  },
  {
    src: videoAdShowcase2,
    label: "AI avatar video ads",
    title: "Create UGC-style product videos without filming creators",
    text: "Build product-led ads with an AI avatar, subtitles and voiceover so shoppers can quickly understand what your product does and why they need it.",
    bullets: [
      "AI avatar presents and demonstrates your product",
      "Voiceover and subtitles reinforce your sales message",
      "Built for scroll-stopping paid social video ads",
    ],
    tags: ["UGC-style", "Subtitles", "Voiceover"],
    cta: "Create my avatar video",
  },
  {
    src: videoAdShowcase3,
    label: "Image ad creatives",
    title: "Turn simple product photos into polished ad creatives",
    text: "Use the photos you already have and generate benefit-focused visuals for new hooks, audiences and campaigns without waiting for a designer.",
    bullets: [
      "Transform plain product shots into promotional images",
      "Show benefits and product context more clearly",
      "Test multiple creative directions every week",
    ],
    tags: ["Photo in", "Ad out", "More variants"],
    cta: "Generate my image creatives",
  },
  {
    src: videoAdShowcase4,
    label: "Full creative workflow",
    title: "Get image ads, video ads and UGC content from one product",
    text: "From product extraction to social-ready outputs, PixelAds helps you cover the formats shoppers see before they decide to buy.",
    bullets: [
      "Image ads for offers, benefits and product angles",
      "Video ads for demonstrations and stronger attention",
      "UGC-style creatives that feel native in the feed",
    ],
    tags: ["Ad image", "Video ad", "UGC"],
    cta: "Build my complete ad kit",
  },
];

/* -------------------- Public fetch helper (unauthenticated) --------------- */
async function fetchFirstOkJson(urls) {
  const list = Array.isArray(urls) ? urls.filter(Boolean) : [];
  let lastErr;

  for (const u of list) {
    try {
      const url = `${u}${u.includes("?") ? "&" : "?"}ts=${Date.now()}`;
      const r = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json", "Cache-Control": "no-store" },
        cache: "no-store",
      });

      // If endpoint is protected, try the next candidate (Landing is unauthenticated)
      if (r.status === 401 || r.status === 403) {
        lastErr = new Error(`auth ${r.status}`);
        continue;
      }

      if (!r.ok) {
        lastErr = new Error(`http ${r.status}`);
        continue;
      }

      const data = await r.json();
      return { data, source: u };
    } catch (e) {
      lastErr = e;
    }
  }

  throw lastErr || new Error("no_public_endpoint");
}

/* -------------------- Lazy media rendering for a faster landing page ------- */
const LazyAutoplayVideo = memo(function LazyAutoplayVideo({
  src,
  className = "",
  ariaLabel,
  eager = false,
}) {
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(eager);
  const [isVisible, setIsVisible] = useState(eager);

  useEffect(() => {
    const node = videoRef.current;
    if (!node) return undefined;

    if (eager) {
      setShouldLoad(true);
      setIsVisible(true);
      return undefined;
    }

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setShouldLoad(true);
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        rootMargin: "220px 0px",
        threshold: 0.01,
      }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [eager]);

  useEffect(() => {
    const node = videoRef.current;
    if (!node || !shouldLoad) return undefined;

    if (isVisible) {
      const playPromise = node.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    } else {
      node.pause();
    }

    return undefined;
  }, [isVisible, shouldLoad]);

  return (
    <video
      ref={videoRef}
      src={shouldLoad ? src : undefined}
      className={className}
      muted
      loop
      playsInline
      preload={eager ? "metadata" : "none"}
      aria-label={ariaLabel}
    />
  );
});

/* -------------------- Small media preview used in Features blocks --------- */
const FeatureMediaPreview = memo(function FeatureMediaPreview({
  mediaKey,
  eager = false,
  mobileProminent = false,
}) {
  const media = mediaKey ? FEATURE_MEDIA[mediaKey] : null;
  const isAvatarVideo = mediaKey === "adMarketingVideo";

  return (
    <div className="w-full">
      <div
        className={`relative w-full ${
          mobileProminent ? "h-[340px] sm:h-[320px]" : "h-[260px] sm:h-[320px]"
        } rounded-2xl overflow-hidden border border-white/8 bg-black shadow-[0_16px_40px_rgba(0,0,0,0.8)]`}
      >
        {!media ? (
          <img
            src={placeholderImage}
            alt="Feature preview"
            className="w-full h-full object-cover"
            draggable={false}
            loading="lazy"
            decoding="async"
            onError={useLoginAvatarFallback}
          />
        ) : media.type === "image" ? (
          <img
            src={media.src}
            alt="Feature preview"
            className="w-full h-full object-cover"
            draggable={false}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            onError={useLoginAvatarFallback}
          />
        ) : (
          <LazyAutoplayVideo
            src={media.src}
            eager={eager}
            className={`w-full h-full object-cover ${
              isAvatarVideo ? "object-top" : ""
            }`}
            ariaLabel="Feature preview video"
          />
        )}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
    </div>
  );
});

function getDropdownPreviewSrc(media) {
  if (!media) return placeholderImage;
  if (media.type !== "video") return media.src;

  return media.src
    .replace(
      "/video/upload/",
      "/video/upload/so_0,w_176,h_112,c_fill,q_auto,f_auto/"
    )
    .replace(/\.mp4($|\?)/, ".jpg$1");
}

/* -------------------- Tiny preview used inside the Features dropdown ------- */
const DropdownMediaPreview = memo(function DropdownMediaPreview({ mediaKey }) {
  const media = mediaKey ? FEATURE_MEDIA[mediaKey] : null;

  return (
    <img
      src={getDropdownPreviewSrc(media)}
      alt=""
      className="w-full h-full object-cover"
      loading="lazy"
      decoding="async"
      draggable={false}
      onError={useLoginAvatarFallback}
    />
  );
});

/* -------------------- Partners carousel (ONLY provided partner logos) ----- */
function PartnersCarousel() {
  const partners = [
    { src: partnerLogo1, alt: "Partner logo 1" },
    { src: partnerLogo2, alt: "Partner logo 2" },
    { src: partnerLogo3, alt: "Partner logo 3" },
    { src: partnerLogo6, alt: "Partner logo 6" },
  ];

  // Duplicate for seamless loop
  const track = [...partners, ...partners, ...partners];

  return (
    <div className="w-full">
      <style>{`
        @keyframes partners-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .partners-track {
          width: 200%;
          animation: partners-marquee 22s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .partners-track { animation: none; transform: translateX(0); }
        }
      `}</style>

      <div
        className="relative overflow-hidden rounded-2xl border border-white/10 bg-black/25 px-3 py-3 shadow-[0_16px_40px_rgba(0,0,0,0.55)]"
        style={{
          WebkitMaskImage:
            "linear-gradient(90deg, transparent 0%, black 10%, black 90%, transparent 100%)",
          maskImage:
            "linear-gradient(90deg, transparent 0%, black 10%, black 90%, transparent 100%)",
        }}
      >
        <div className="partners-track flex items-center gap-3">
          {track.map((p, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <div
              key={`${p.alt}-${idx}`}
              className="flex-shrink-0 rounded-2xl border border-white/12 bg-white/5 px-4 py-2"
            >
              <img
                src={p.src}
                alt={p.alt}
                className="h-7 sm:h-8 w-auto select-none opacity-95"
                loading="lazy"
                decoding="async"
                draggable={false}
                onError={useLoginAvatarFallback}
              />
            </div>
          ))}
        </div>

        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#050516] via-transparent to-[#050516] opacity-60" />
      </div>
    </div>
  );
}

/* -------------------- Real outputs showcase restored from Landing 2 ------- */
const RealOutputsShowcase = memo(function RealOutputsShowcase() {
  const sectionRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handleMotionChange = () => setReduceMotion(mediaQuery.matches);

    handleMotionChange();
    mediaQuery.addEventListener?.("change", handleMotionChange);

    return () => mediaQuery.removeEventListener?.("change", handleMotionChange);
  }, []);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { rootMargin: "140px 0px", threshold: 0.05 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible || reduceMotion || REAL_OUTPUT_ITEMS.length < 2) return undefined;

    const id = window.setInterval(
      () => setIndex((previous) => (previous + 1) % REAL_OUTPUT_ITEMS.length),
      2600
    );

    return () => window.clearInterval(id);
  }, [isVisible, reduceMotion]);

  const current = REAL_OUTPUT_ITEMS[index];

  return (
    <section ref={sectionRef} className="mt-10 w-full">
      <div className="max-w-6xl mx-auto px-4">
        <div className="rounded-3xl border border-white/10 bg-black/40 p-4 sm:p-6 shadow-[0_22px_50px_rgba(0,0,0,0.85)]">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="md:w-[40%] text-slate-50 text-center md:text-left">
              <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.18em] text-pink-300">
                Real outputs
              </p>
              <h3 className="mt-1 text-lg sm:text-xl font-semibold">
                One product page can become a full library of ads
              </h3>
              <p className="mt-2 text-xs sm:text-sm text-slate-300">
                These previews come from the same tools inside your dashboard: avatar videos, product photoshoots, background edits, object edits, restorations, and more.
              </p>

              <div className="mt-4 inline-flex flex-wrap items-center justify-center md:justify-start gap-2 rounded-full bg-white/5 border border-white/15 px-3 py-1.5">
                <span className="text-xs sm:text-sm font-medium text-slate-50">
                  Rated <span className="font-semibold">“Excellent” 4.8/5</span>
                </span>
                <div className="flex gap-0.5 text-yellow-400">
                  {[0, 1, 2, 3, 4].map((item) => (
                    <Star
                      key={item}
                      className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400"
                    />
                  ))}
                </div>
                <span className="hidden sm:inline text-xs text-slate-300">
                  by ecommerce marketers using PixelAds
                </span>
              </div>
            </div>

            <div className="md:flex-1 w-full">
              <div className="mb-3 flex justify-center">
                <span className="text-xs sm:text-sm font-semibold text-slate-50 underline underline-offset-4 decoration-pink-400">
                  {current.title}
                </span>
              </div>

              <div className="relative w-full max-w-3xl mx-auto aspect-[4/5] sm:aspect-[4/3] rounded-3xl overflow-hidden border border-white/10 bg-[#050516] flex items-center justify-center">
                <img
                  key={current.src}
                  src={current.src}
                  alt={current.title}
                  className="absolute inset-0 h-full w-full object-contain transition-opacity duration-700 opacity-100"
                  draggable={false}
                  loading="lazy"
                  decoding="async"
                  onError={useLoginAvatarFallback}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <Link
            to="/signup"
            className="inline-flex w-full items-center justify-center rounded-xl bg-[#F82E88] px-6 py-3 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(248,46,136,0.45)] transition hover:-translate-y-[1px] hover:brightness-110 sm:w-auto"
          >
            Start creating video ads free
          </Link>
        </div>
      </div>
    </section>
  );
});

/* -------------------- Integration trust card ------------------------------ */
const IntegrationsCard = memo(function IntegrationsCard() {
  return (
    <section className="mt-8 w-full max-w-6xl mx-auto px-4 text-slate-50">
      <div className="rounded-3xl border border-white/10 bg-black/40 px-5 py-6 sm:px-8 sm:py-7 shadow-[0_20px_60px_rgba(0,0,0,0.75)] flex flex-col items-center text-center">
        <h3 className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.22em] text-slate-300">
          Trusted &amp; Integrated with
        </h3>

        <div className="mt-4 w-full max-w-3xl">
          <PartnersCarousel />
        </div>
      </div>
    </section>
  );
});

/* -------------------- Conversion showcase sections below the hero --------- */
function ConversionShowcaseSections() {
  return (
    <section id="video-types" className="mt-8 w-full">
      <div className="mx-auto max-w-6xl px-4">
        <div className="rounded-[34px] border border-pink-500/25 bg-[radial-gradient(circle_at_top,rgba(91,78,255,0.18),rgba(5,5,22,0.96)_48%)] px-5 py-8 shadow-[0_30px_90px_rgba(0,0,0,0.78)] sm:px-8 sm:py-10">
          <div className="mx-auto max-w-4xl text-center text-slate-50">
            <h2 className="text-2xl font-bold tracking-tight sm:text-4xl">
              One product page. Ads, UGC-style videos and creatives ready to test.
            </h2>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-7 text-slate-300 sm:text-base">
              PixelAds turns the product content you already have into the visuals
              shoppers need to notice, understand and want your offer. See exactly
              what you can create before you sign up.
            </p>
          </div>

          <div className="mt-9 space-y-5 sm:space-y-7">
            {VIDEO_AD_SHOWCASE_SLIDES.map((item, index) => (
              <article
                key={item.title}
                className="overflow-hidden rounded-[28px] border border-white/10 bg-[#070716] shadow-[0_20px_56px_rgba(0,0,0,0.62)]"
              >
                <div className="border-b border-white/10 bg-[#03030e] p-2.5 sm:p-4">
                  <img
                    src={item.src}
                    alt={item.title}
                    className="block h-auto w-full rounded-[20px] object-contain"
                    loading="lazy"
                    decoding="async"
                    draggable={false}
                  />
                </div>

                <div className="p-6 sm:p-8 lg:p-10">
                  <div className="mx-auto max-w-4xl">
                    <div className="flex items-center gap-3">
                      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-pink-400/30 bg-pink-500/10 text-xs font-semibold text-pink-200">
                        {index + 1}
                      </span>
                      <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-pink-300">
                        {item.label}
                      </span>
                    </div>

                    <h3 className="mt-4 text-xl font-bold tracking-tight text-white sm:text-2xl">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm leading-7 text-slate-300 sm:text-[15px]">
                      {item.text}
                    </p>

                    <div className="mt-5 space-y-3">
                      {item.bullets.map((point) => (
                        <div key={point} className="flex items-start gap-2.5">
                          <Check className="mt-0.5 h-4 w-4 shrink-0 text-pink-400" />
                          <span className="text-sm leading-6 text-slate-200">
                            {point}
                          </span>
                        </div>
                      ))}
                    </div>

                    <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                      <div className="flex flex-wrap gap-2">
                        {item.tags.map((tag) => (
                          <span
                            key={tag}
                            className="rounded-full border border-white/10 bg-white/[0.045] px-3 py-1.5 text-[11px] font-medium text-slate-200"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>

                      <Link
                        to="/signup"
                        className="inline-flex shrink-0 self-end items-center justify-center rounded-xl bg-[#F82E88] px-4 py-2.5 text-sm font-semibold text-white shadow-[0_10px_26px_rgba(248,46,136,0.35)] transition hover:-translate-y-[1px] hover:brightness-110"
                      >
                        {item.cta}
                      </Link>
                    </div>
                  </div>
                </div>
              </article>
            ))}

            <article className="overflow-hidden rounded-[28px] border border-pink-500/25 bg-[#070716] shadow-[0_20px_56px_rgba(0,0,0,0.62)]">
              <div className="border-b border-white/10 bg-[#03030e] p-2.5 sm:p-4">
                <div className="overflow-hidden rounded-[20px] border border-white/10 bg-black">
                  <LazyAutoplayVideo
                    src={videoAdExplanation}
                    className="block h-auto w-full object-contain"
                    ariaLabel="PixelAds product URL to ad creative workflow preview"
                  />
                </div>
                <div className="mt-3 flex items-center justify-between gap-3 px-1 pb-1">
                  <p className="text-xs text-slate-400">
                    Product input → ad creatives → promotional video content
                  </p>
                </div>
              </div>

              <div className="p-6 sm:p-8 lg:p-10">
                <div className="mx-auto max-w-4xl">
                  <div className="flex items-center gap-3">
                    <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-pink-400/30 bg-pink-500/10 text-xs font-semibold text-pink-200">
                      5
                    </span>
                    <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-pink-300">
                      Watch PixelAds in action
                    </span>
                  </div>

                  <h3 className="mt-4 text-xl font-bold tracking-tight text-white sm:text-2xl">
                    Watch a product become promotional content
                  </h3>
                  <p className="mt-3 text-sm leading-7 text-slate-300 sm:text-[15px]">
                    See how one product input turns into image ads, video ads and
                    UGC-style content you can use to promote your offer.
                  </p>

                  <div className="mt-5 space-y-3">
                    {[
                      "Show the product with stronger ad-ready visuals",
                      "Explain the value through video and avatar content",
                      "Create more assets without a full creative production cycle",
                    ].map((point) => (
                      <div key={point} className="flex items-start gap-2.5">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-pink-400" />
                        <span className="text-sm leading-6 text-slate-200">
                          {point}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/[0.045] px-5 py-5 text-center sm:flex-row sm:text-left">
            <div>
              <p className="text-base font-semibold text-white">
                Ready to turn your products into ads people want to click?
              </p>
              <p className="mt-1 text-sm text-slate-300">
                Paste a product link and generate your first promotion-ready assets.
              </p>
            </div>
            <Link
              to="/signup"
              className="inline-flex shrink-0 items-center justify-center rounded-xl bg-[#F82E88] px-5 py-3 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(248,46,136,0.45)] transition hover:-translate-y-[1px] hover:brightness-110"
            >
              Start creating free
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

/* -------------------- Trustpilot (bigger, PagePilot-style) ---------------- */
function SocialProofBar() {
  return (
    <div className="w-full flex flex-col items-center">
      <div className="inline-flex items-center gap-4 rounded-[22px] border border-white/12 bg-black/45 px-5 sm:px-6 py-3 sm:py-3.5 shadow-[0_18px_44px_rgba(0,0,0,0.60)]">
        <img
          src={trustpilotLogo}
          alt="Trustpilot"
          className="h-8 sm:h-9 w-auto select-none"
          loading="lazy"
          decoding="async"
          draggable={false}
          onError={useLoginAvatarFallback}
        />
        <div className="flex items-center gap-0.5 text-yellow-400">
          {[0, 1, 2, 3, 4].map((i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <div className="text-sm sm:text-base text-slate-100">
          <span className="font-semibold">Excellent</span>{" "}
          <span className="text-slate-300">4.8/5</span>
        </div>
      </div>
    </div>
  );
}

const LovedByPill = memo(function LovedByPill() {
  const heroAvatars = [avatar1, avatar2, avatar3, avatar4];

  return (
    <div className="inline-flex flex-col items-center justify-center gap-3 rounded-2xl border border-white/20 bg-white/[0.06] px-5 py-3 shadow-[0_14px_34px_rgba(0,0,0,0.45)] sm:flex-row">
      <div className="flex items-center">
        {heroAvatars.map((src, idx) => (
          <img
            key={src}
            src={src}
            alt=""
            width={38}
            height={38}
            className={`h-9 w-9 rounded-full border border-white/20 bg-[#0B0B18] object-cover ${
              idx === 0 ? "" : "-ml-2"
            }`}
            loading="eager"
            decoding="async"
            draggable={false}
            onError={useLoginAvatarFallback}
          />
        ))}
      </div>

      <div className="flex items-center gap-2">
        <div className="flex items-center gap-0.5 text-yellow-400">
          {[0, 1, 2, 3, 4].map((i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <span className="text-sm text-slate-100 sm:text-base">
          Loved by <span className="font-bold">41,449</span> users
        </span>
      </div>
    </div>
  );
});

/* -------------------- High-impact metrics shown after the showcase -------- */
function ImpactStats() {
  const stats = [
    {
      big: "10×",
      text: "Faster ad production than doing it manually",
    },
    {
      big: "3×",
      text: "More creatives and angles tested every week",
    },
    {
      big: "<1h",
      text: "To go from product page to first avatar video",
    },
    {
      big: "24/7",
      text: "Create new product ads whenever you need to launch or test",
    },
  ];

  return (
    <section className="mt-8 w-full">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-5 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-pink-300 sm:text-xs">
            Built for ecommerce speed
          </p>
          <h2 className="mt-2 text-xl font-semibold text-white sm:text-2xl">
            Go from product page to test-ready ads, faster
          </h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat) => (
            <div
              key={stat.big}
              className="rounded-[28px] border border-white/10 bg-black/35 p-5 shadow-[0_24px_60px_rgba(0,0,0,0.75)] sm:p-6"
            >
              <div className="bg-gradient-to-r from-white via-white to-pink-300 bg-clip-text text-3xl font-extrabold tracking-tight text-transparent sm:text-4xl">
                {stat.big}
              </div>
              <div className="mt-3 text-sm leading-6 text-slate-200 sm:text-base">
                {stat.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* -------------------- Reviews section (memoized) -------------------------- */

const SignupBonusCard = memo(function SignupBonusCard({
  signupBonus,
  compact = false,
  className = "",
  showLovedBy = false,
  ctaLabel = "Claim my free ad video",
}) {
  return (
    <div className={className}>
      <div
        className="mx-auto flex h-full max-w-6xl flex-col rounded-3xl border p-5 sm:p-6"
        style={{
          borderColor: `${GREEN}55`,
          background:
            "linear-gradient(180deg, rgba(34,197,94,0.10) 0%, rgba(18,18,40,0.92) 100%)",
          boxShadow: "0 14px 34px rgba(0,0,0,0.30)",
        }}
      >
        <div className="flex flex-col items-center text-center gap-4">
          <div className="w-full">
            <div className="flex items-center justify-center gap-2">
              <span
                className="px-3 py-1 rounded-full text-[11px] font-extrabold tracking-wide uppercase"
                style={{
                  background: GREEN,
                  color: "#04110D",
                  boxShadow: "0 10px 24px rgba(34,197,94,0.30)",
                  letterSpacing: "0.06em",
                }}
              >
                Free on signup
              </span>
            </div>

            <div className="mt-2 text-white text-xl sm:text-2xl font-extrabold">
              Start instantly — no credit card needed
            </div>
            <div className="mt-1 text-gray-200/90 text-sm sm:text-base">
              Every new account automatically receives a one-time starter
              bundle.
            </div>
          </div>
        </div>

        <div className={`mt-5 grid grid-cols-1 ${compact ? "sm:grid-cols-3" : "sm:grid-cols-3"} gap-3`}>
          <div
            className="rounded-2xl border px-4 py-4 flex items-center justify-between"
            style={{
              background: "#0f0f21",
              borderColor: BORDER,
              boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03)",
            }}
          >
            <div className="flex items-center gap-3">
              <ImageIcon className="w-6 h-6 text-gray-200" />
              <div className="text-left">
                <div className="text-gray-200 text-sm font-semibold">
                  AI Images
                </div>
                <div className="text-gray-500 text-xs">one-time bonus</div>
              </div>
            </div>
            <div className="text-white text-3xl font-extrabold tracking-tight">
              {signupBonus.images}
            </div>
          </div>

          <div
            className="rounded-2xl border px-4 py-4 flex items-center justify-between"
            style={{
              background:
                "linear-gradient(180deg, rgba(248,46,136,0.10) 0%, rgba(20,20,40,0.85) 100%)",
              borderColor: `${ACCENT}55`,
              boxShadow: `0 0 0 1px ${ACCENT}22 inset`,
            }}
          >
            <div className="flex items-center gap-3">
              <Film className="w-6 h-6 text-gray-200" />
              <div className="text-left">
                <div className="text-gray-200 text-sm font-semibold">
                  AI Videos
                </div>
                <div className="text-gray-500 text-xs">one-time bonus</div>
              </div>
            </div>
            <div className="text-white text-3xl font-extrabold tracking-tight">
              {signupBonus.videos}
            </div>
          </div>

          <div
            className="rounded-2xl border px-4 py-4 flex items-center justify-between"
            style={{
              background: "#0f0f21",
              borderColor: BORDER,
              boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03)",
            }}
          >
            <div className="flex items-center gap-3">
              <LinkIcon className="w-6 h-6 text-gray-200" />
              <div className="text-left">
                <div className="text-gray-200 text-sm font-semibold">
                  Product Pages
                </div>
                <div className="text-gray-500 text-xs">one-time bonus</div>
              </div>
            </div>
            <div className="text-white text-3xl font-extrabold tracking-tight">
              {signupBonus.urls}
            </div>
          </div>
        </div>

        <div className={`${showLovedBy ? "mt-auto pt-12 sm:pt-16" : "mt-6"} flex justify-center`}>
          <Link
            to="/signup"
            className="inline-flex w-full items-center justify-center rounded-xl bg-[#F82E88] px-6 py-3 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(248,46,136,0.45)] transition hover:-translate-y-[1px] hover:brightness-110 sm:w-auto"
          >
            {ctaLabel}
          </Link>
        </div>

        {showLovedBy && (
          <div className="mt-8 flex flex-col items-center justify-center gap-2">
            <LovedByPill />
            <div className="text-center text-[12px] text-slate-400">
              <span className="font-semibold text-slate-200">
                No credit card required
              </span>{" "}
              • Product URL or image to get started • UGC, product demos, explainers and paid ads
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

const ReviewsSection = memo(function ReviewsSection() {
  return (
    <section id="reviews" className="mt-12 w-full">
      <div className="max-w-6xl mx-auto px-4">
        <div className="rounded-3xl border border-white/10 bg-black/40 p-6 sm:p-8 shadow-[0_22px_60px_rgba(0,0,0,0.8)]">
          <div className="text-center text-slate-50">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/12 px-3 py-1.5">
              <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-pink-200">
                Reviews
              </span>
            </div>
            <h2 className="mt-3 text-2xl sm:text-3xl font-semibold">
              Built for sellers who need more winning creatives, faster
            </h2>
            <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-2xl mx-auto">
              From store owners to paid media teams, PixelAds helps people launch faster without slowing down on production.
            </p>
          </div>

          <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {AIAPPLY_STYLE_REVIEWS.map((r) => (
              <figure
                key={`${r.name}-${r.role}`}
                className="rounded-2xl bg-[#111124] border border-white/10 p-4 shadow-[0_14px_34px_rgba(0,0,0,0.65)]"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={r.avatar}
                    alt={r.name}
                    width={40}
                    height={40}
                    className="h-10 w-10 rounded-full object-cover border border-white/12 bg-[#0B0B18] flex-shrink-0"
                    loading="lazy"
                    decoding="async"
                    draggable={false}
                    onError={useLoginAvatarFallback}
                  />
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-slate-50 truncate">
                      {r.name}
                    </div>
                    <div className="text-xs text-slate-400 truncate">{r.role}</div>
                    <div className="mt-1 flex items-center gap-0.5 text-yellow-400">
                      {[0, 1, 2, 3, 4].map((i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Star
                          key={i}
                          className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400"
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <blockquote className="mt-3 text-xs sm:text-sm text-slate-200">
                  “{r.quote}”
                </blockquote>
              </figure>
            ))}
          </div>

          <div className="mt-7 flex justify-center">
            <Link
              to="/signup"
              className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#605DFF] to-[#A855F7] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_14px_32px_rgba(96,93,255,0.5)] hover:brightness-105 hover:-translate-y-[1px] transition"
            >
              Start free
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
});

/* -------------------- Isolated header dropdown for fast interaction ------- */
const FeaturesDropdown = memo(function FeaturesDropdown({ onSelectFeature }) {
  const [featuresOpen, setFeaturesOpen] = useState(false);
  const featuresRef = useRef(null);

  useEffect(() => {
    if (!featuresOpen) return undefined;

    const handleClickOutside = (event) => {
      if (featuresRef.current && !featuresRef.current.contains(event.target)) {
        setFeaturesOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") setFeaturesOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [featuresOpen]);

  return (
    <div className="relative" ref={featuresRef}>
      <button
        type="button"
        onClick={() => setFeaturesOpen((open) => !open)}
        className="inline-flex items-center gap-1 rounded-full border border-transparent px-3 py-1.5 hover:border-white/15 hover:bg-white/5 transition-colors"
        aria-expanded={featuresOpen}
        aria-controls="features-menu"
      >
        <span className="text-sm">Features</span>
        <ChevronDown
          size={14}
          className={`transition-transform ${
            featuresOpen ? "rotate-180" : "rotate-0"
          }`}
        />
      </button>

      {featuresOpen && (
        <div
          id="features-menu"
          className="absolute left-1/2 mt-3 max-w-[calc(100vw-2rem)] w-[1040px] -translate-x-1/2 rounded-3xl bg-[#050516] border border-white/12 shadow-[0_24px_60px_rgba(0,0,0,0.9)] overflow-hidden origin-top transform transition-all duration-200 ease-out opacity-100 scale-100 translate-y-0 pointer-events-auto"
        >
          <div className="px-5 py-4">
            <div className="flex items-center justify-between mb-3">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Features
              </div>
              <div className="hidden sm:flex items-center gap-1 text-[11px] text-slate-400">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400/80" />
                <span>
                  Built on Phot.AI, TopView.AI, Cloudinary &amp; OpenAI
                </span>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {FEATURES.map((feature) => (
                <button
                  key={feature.id}
                  type="button"
                  onClick={() => {
                    onSelectFeature(feature.id);
                    setFeaturesOpen(false);
                  }}
                  className="group w-full flex items-stretch gap-3 rounded-2xl border border-transparent bg-white/0 px-3.5 py-3 text-left text-slate-100 transition-all duration-150 ease-out hover:-translate-y-[1px] hover:bg-white/5 hover:border-pink-500/40 hover:text-pink-100 hover:shadow-[0_12px_32px_rgba(0,0,0,0.65)]"
                >
                  <div className="flex items-start gap-3 flex-1 min-w-0">
                    {feature.mediaKey && (
                      <div className="w-[88px] h-[56px] rounded-xl overflow-hidden border border-white/10 bg-black/60 flex-shrink-0">
                        <DropdownMediaPreview mediaKey={feature.mediaKey} />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="text-[11px] uppercase tracking-wide text-pink-300/85">
                        {feature.category}
                      </div>
                      <div className="text-sm font-semibold truncate">
                        {feature.title}
                      </div>
                      <div className="mt-1 text-xs text-slate-400 line-clamp-2">
                        {feature.description}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

/* -------------------- Isolated countdown to avoid page-wide re-renders ----- */
const DailyDealCountdown = memo(function DailyDealCountdown() {
  const [, setDailyDealEndsAt] = useState(() =>
    resolveNextDailyDealEndsAt()
  );
  const [countdownMs, setCountdownMs] = useState(() =>
    Math.max(0, resolveNextDailyDealEndsAt() - Date.now())
  );

  useEffect(() => {
    const syncCountdown = () => {
      setDailyDealEndsAt((previousEndsAt) => {
        const currentEndsAt =
          Number.isFinite(previousEndsAt) && previousEndsAt > Date.now()
            ? previousEndsAt
            : resolveNextDailyDealEndsAt();

        if (currentEndsAt <= Date.now()) {
          const rolledEndsAt = rolloverDailyDealEndsAt();
          setCountdownMs(Math.max(0, rolledEndsAt - Date.now()));
          return rolledEndsAt;
        }

        setCountdownMs(Math.max(0, currentEndsAt - Date.now()));
        return currentEndsAt;
      });
    };

    syncCountdown();
    const intervalId = window.setInterval(syncCountdown, 1000);
    return () => window.clearInterval(intervalId);
  }, []);

  const countdownParts = getCountdownParts(countdownMs);

  return (
    <div className="mt-6 rounded-[28px] border border-[#F59E0B33] bg-[linear-gradient(135deg,rgba(248,46,136,0.16)_0%,rgba(96,93,255,0.12)_50%,rgba(245,158,11,0.14)_100%)] p-4 sm:p-5 shadow-[0_16px_34px_rgba(0,0,0,0.35)]">
      <div className="text-center">
        <div className="text-[13px] sm:text-[15px] font-semibold uppercase tracking-[0.18em] text-amber-200/95">
          Limited-time launch discount
        </div>
        <div className="mt-1 text-sm sm:text-base font-medium text-slate-200">
          Grab it while it’s hot — this deal refreshes every 24 hours.
        </div>
      </div>

      <div className="mt-4 mx-auto grid max-w-xl grid-cols-3 gap-2 sm:gap-3">
        {[
          { label: "Hours", value: countdownParts.hours },
          { label: "Minutes", value: countdownParts.minutes },
          { label: "Seconds", value: countdownParts.seconds },
        ].map((part) => (
          <div
            key={part.label}
            className="rounded-2xl border border-white/10 bg-[#0B0B19]/90 px-2 py-3 sm:px-3 sm:py-4 text-center shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]"
          >
            <div className="bg-gradient-to-b from-white to-pink-200 bg-clip-text text-2xl sm:text-3xl font-black tracking-[0.08em] text-transparent">
              {part.value}
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-[0.16em] text-slate-400">
              {part.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

/* -------------------- Page ------------------------------------------------ */
export default function Landing() {
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  // ✅ Promo config (DB-backed)
  const [promo, setPromo] = useState(DEFAULT_PROMO);

  // ✅ Starter bundle (DB-backed when available)
  const [signupBonus, setSignupBonus] = useState(DEFAULT_SIGNUP_BONUS);

  // ✅ Pricing + topups (DB-backed, same source as Pricing.jsx, but PUBLIC)
  const [pricingPlans, setPricingPlans] = useState(FALLBACK_LANDING_PLANS_VIEW);
  const [addons, setAddons] = useState([]); // kept for parity with Pricing.jsx (even if not rendered here)

  // ✅ track which public endpoint actually served the pricing payload (hidden)
  const [pricingSource, setPricingSource] = useState("");

  // ✅ measure promo + header heights (promo can wrap on mobile)
  const promoRef = useRef(null);
  const headerRef = useRef(null);
  const [promoHeight, setPromoHeight] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(64);

  const [billingCycle, setBillingCycle] = useState("monthly");

  useEffect(() => {
    void clearStaleClientCaches();
  }, []);

  const measureBars = useCallback(() => {
    const ph =
      promo.enabled && promoRef.current?.getBoundingClientRect?.().height
        ? promoRef.current.getBoundingClientRect().height
        : 0;

    const hh = headerRef.current?.getBoundingClientRect?.().height || 0;

    setPromoHeight(ph || 0);
    if (hh) setHeaderHeight(hh);
  }, [promo.enabled]);


  const loadPromo = useCallback(async () => {
    try {
      const url = `${API_BASE}/api/landing/promo-strip?ts=${Date.now()}`;
      const r = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json", "Cache-Control": "no-store" },
        cache: "no-store",
      });

      if (!r.ok) throw new Error(`promo http ${r.status}`);

      const data = await r.json();
      const next = sanitizePromo(data?.promo || {});
      setPromo(next);
    } catch (_e) {
      setPromo((prev) => prev || DEFAULT_PROMO);
    }
  }, []);

  // ✅ Pricing + addons + signup bonus (same parsing logic as Pricing.jsx, but unauthenticated)
  const loadPricingAndAddons = useCallback(async () => {
    try {
      // Landing is PUBLIC: try multiple potential public routes (in case /api/billing/plans is auth-protected)
      // ✅ IMPORTANT: include "public=1" variants first because many backends gate /plans with auth unless public flag is present
      const plansCandidates = [
        `${API_BASE}/api/billing/plans?public=1`,
        `${API_BASE}/api/billing/topups?public=1`, // harmless if it returns non-plans; we ignore later
        `${API_BASE}/api/billing/public/plans`,
        `${API_BASE}/api/billing/public/plans?public=1`,
        `${API_BASE}/api/billing/plans-public`,
        `${API_BASE}/api/billing/plans-public?public=1`,
        `${API_BASE}/api/public/billing/plans`,
        `${API_BASE}/api/public/billing/plans?public=1`,
        `${API_BASE}/api/landing/plans`,
        `${API_BASE}/api/landing/pricing`,
        `${API_BASE}/api/public/pricing`,
        `${API_BASE}/api/pricing`,
        `${API_BASE}/api/config/pricing`,
      ];

      const topupsCandidates = [
        `${API_BASE}/api/billing/topups?public=1`,
        `${API_BASE}/api/billing/public/topups`,
        `${API_BASE}/api/billing/public/topups?public=1`,
        `${API_BASE}/api/billing/topups-public`,
        `${API_BASE}/api/billing/topups-public?public=1`,
        `${API_BASE}/api/public/billing/topups`,
        `${API_BASE}/api/public/billing/topups?public=1`,
        `${API_BASE}/api/landing/topups`,
        `${API_BASE}/api/public/topups`,
        `${API_BASE}/api/topups`,
      ];

      const [plansRes, topupsResMaybe] = await Promise.all([
        fetchFirstOkJson(plansCandidates),
        fetchFirstOkJson(topupsCandidates).catch(() => null),
      ]);

      const plansData = plansRes?.data || {};
      const topupsDataMaybe = topupsResMaybe?.data || null;

      setPricingSource(plansRes?.source || "");

      // ✅ Signup bonus: accept the same shapes/aliases as Pricing.jsx
      const sb = extractSignupBonusFromPlansPayload(plansData || {});
      setSignupBonus(sb);

      // ✅ Plans: accept array form OR derive from tier config (starter/pro/business) if API returns config object
      const fetchedPlans = Array.isArray(plansData?.plans)
        ? plansData.plans
        : Array.isArray(plansData?.tiers)
          ? plansData.tiers
          : Array.isArray(plansData?.data?.plans)
            ? plansData.data.plans
            : Array.isArray(plansData?.data?.tiers)
              ? plansData.data.tiers
              : [];

      const deriveFromConfig = () => {
        const cfg =
          plansData?.caps ||
          plansData?.tier_caps ||
          plansData?.tierCaps ||
          plansData?.tiercaps ||
          plansData?.config ||
          plansData?.pricing ||
          plansData?.data?.caps ||
          plansData?.data?.tier_caps ||
          plansData?.data?.tierCaps ||
          plansData?.data?.tiercaps ||
          plansData?.data?.config ||
          plansData?.data?.pricing ||
          null;

        const cfgTiers =
          cfg?.tiers ||
          cfg?.tier_caps ||
          cfg?.tierCaps ||
          cfg?.tiercaps ||
          null;

        const root = cfgTiers || cfg;

        if (!root) return [];

        const tiers = ["starter", "pro", "business"];
        const labels = { starter: "Starter", pro: "Pro", business: "Business" };

        return tiers
          .map((t) => {
            const o = root?.[t] || {};
            // prices in config are usually: price_monthly_eur / price_yearly_eur
            const m = pickFirst(
              o.priceEurMonthly,
              o.price_monthly_eur,
              o.monthly_price_eur,
              o.priceMonthlyEur,
              o.monthlyPriceEur,
              o.monthly_price,
              o.price_monthly,
              parseEuroFromLabel(o.priceLabelMonthly),
              parseEuroFromLabel(o.monthlyLabel),
              parseEuroFromLabel(o.label_monthly)
            );
            const y = pickFirst(
              o.priceEurYearly,
              o.price_yearly_eur,
              o.yearly_price_eur,
              o.priceYearlyEur,
              o.yearlyPriceEur,
              o.yearly_price,
              o.price_yearly,
              parseEuroFromLabel(o.priceLabelYearly),
              parseEuroFromLabel(o.yearlyLabel),
              parseEuroFromLabel(o.label_yearly)
            );

            return {
              id: t,
              name: labels[t],
              priceEurMonthly: Number(m),
              priceEurYearly: Number(y),
              imagesCap: pickFirst(o.imagesCap, o.images, o.images_per_month),
              videosCap: pickFirst(o.videosCap, o.videos, o.videos_per_month),
              analyzeCap: pickFirst(
                o.analyzeCap,
                o.urls,
                o.pages,
                o.urls_per_month,
                o.pages_per_month
              ),
              mostUsed: t === "pro",
            };
          })
          .filter((p) => p && p.id && p.name);
      };

      const sourcePlans = fetchedPlans.length ? fetchedPlans : deriveFromConfig();

      const mappedViews = sourcePlans
        .map((p) => {
          // normalize id if backend sends uppercase / tier names
          const rawId = asString(p.id ?? p.tier ?? p.key ?? "", "");
          const normId = rawId ? rawId.toLowerCase() : "";

          // prices: support many shapes (Pricing page + backoffice + Stripe label formats)
          const m = pickFirst(
            p.priceEurMonthly,
            p.price_monthly_eur,
            p.monthly_price_eur,
            p.priceMonthlyEur,
            p.monthlyPriceEur,
            p.monthlyPrice,
            p.price_monthly,
            p.priceMonthly,
            parseEuroFromLabel(p.priceLabelMonthly),
            parseEuroFromLabel(p.monthlyPriceLabel),
            parseEuroFromLabel(p.monthly_label),
            parseEuroFromLabel(p.label_monthly),
            parseEuroFromLabel(p.labelMonthly)
          );

          const y = pickFirst(
            p.priceEurYearly,
            p.price_yearly_eur,
            p.yearly_price_eur,
            p.priceYearlyEur,
            p.yearlyPriceEur,
            p.yearlyPrice,
            p.price_yearly,
            p.priceYearly,
            parseEuroFromLabel(p.priceLabelYearly),
            parseEuroFromLabel(p.yearlyPriceLabel),
            parseEuroFromLabel(p.yearly_label),
            parseEuroFromLabel(p.label_yearly),
            parseEuroFromLabel(p.labelYearly)
          );

          // caps: support many shapes
          const imagesCap = capInt(
            pickFirst(
              p.imagesCap,
              p.images_cap,
              p.images,
              p.caps?.images,
              p.caps?.imagesCap,
              p.imagesPerMonth,
              p.images_per_month
            ),
            0
          );

          const videosCap = capInt(
            pickFirst(
              p.videosCap,
              p.videos_cap,
              p.videos,
              p.caps?.videos,
              p.caps?.videosCap,
              p.videosPerMonth,
              p.videos_per_month
            ),
            0
          );

          const analyzeCap = capInt(
            pickFirst(
              p.analyzeCap,
              p.analyze_cap,
              p.urlsCap,
              p.urls_cap,
              p.urls,
              p.pages,
              p.caps?.urls,
              p.caps?.analyze,
              p.caps?.analyzeCap,
              p.pagesPerMonth,
              p.pages_per_month,
              p.urlsPerMonth,
              p.urls_per_month
            ),
            0
          );

          const view = toLandingPlanView({
            id: normId || rawId,
            name: asString(p.name, "") || asString(p.title, "") || rawId,
            priceEurMonthly: Number.isFinite(+m) ? +m : null,
            priceEurYearly: Number.isFinite(+y) ? +y : null,
            // fallbacks if price parsing fails
            monthlyPrice: asString(p.monthlyPrice, asString(p.priceLabelMonthly, "")),
            yearlyPricePerMonth: asString(
              p.yearlyPricePerMonth,
              asString(p.priceLabelYearly, "")
            ),
            yearlyBilled: asString(p.yearlyBilled, ""),
            imagesCap,
            videosCap,
            analyzeCap,
            mostUsed:
              Boolean(p.mostUsed) ||
              Boolean(p.mostPopular) ||
              (normId ? normId === "pro" : String(rawId || "").toLowerCase() === "pro"),
          });

          // Require id + name at minimum
          if (!view.id || !view.name) return null;

          return view;
        })
        .filter(Boolean);

      setPricingPlans(
        mappedViews.length ? mappedViews : FALLBACK_LANDING_PLANS_VIEW
      );

      // ✅ Add-ons: parse prices + amounts like Pricing.jsx (even if not rendered here)
      if (topupsDataMaybe && typeof topupsDataMaybe === "object") {
        const topupsData = topupsDataMaybe;

        const toNonNegInt = (v) => {
          const n = Number(v);
          if (!Number.isFinite(n)) return null;
          return Math.max(0, Math.floor(n));
        };

        const inferAddonFeature = (t) => {
          const bump = t?.bump || null;

          const bi = toNonNegInt(bump?.images);
          const bv = toNonNegInt(bump?.videos);
          const bu = toNonNegInt(bump?.urls);

          if (bi != null) return "images";
          if (bv != null) return "videos";
          if (bu != null) return "urls";

          const id = String(t?.id || "").toLowerCase();
          if (id.startsWith("images_") || id === "images_10") return "images";
          if (id.startsWith("video_") || id === "video_1") return "videos";
          if (id.startsWith("url_") || id === "url_1") return "urls";

          return null;
        };

        const inferAddonAmount = (t, feature) => {
          const direct = Number.isFinite(+t.amount)
            ? Math.max(0, Math.floor(+t.amount))
            : null;
          if (direct != null) return direct;

          const bump = t?.bump || null;
          if (feature === "images") return toNonNegInt(bump?.images);
          if (feature === "videos") return toNonNegInt(bump?.videos);
          if (feature === "urls") return toNonNegInt(bump?.urls);

          const bi = toNonNegInt(bump?.images);
          const bv = toNonNegInt(bump?.videos);
          const bu = toNonNegInt(bump?.urls);
          return bi != null ? bi : bv != null ? bv : bu != null ? bu : null;
        };

        const inferUnitPrice = (t) => {
          const candidates = [
            t.unitPrice,
            t.priceEur,
            t.price_eur,
            t.unit_price,
            t.price,
            t.amountEur,
            t.price_monthly_eur,
            t.priceEurMonthly,
          ];
          for (const c of candidates) {
            const n = Number(c);
            if (Number.isFinite(n)) return n;
          }
          return parseEuroFromLabel(t.label);
        };

        // Accept either: { topups: [...] } OR { addons: { ... } } shape
        const topupsArray = Array.isArray(topupsData?.topups)
          ? topupsData.topups
          : Array.isArray(topupsData?.data?.topups)
            ? topupsData.data.topups
            : null;

        let normalized = [];

        if (topupsArray) {
          normalized = topupsArray
            .filter((t) => String(t.type || "").startsWith("addon"))
            .map((t) => {
              const feature = inferAddonFeature(t);
              const unit = inferUnitPrice(t);
              const amt = inferAddonAmount(t, feature);

              return {
                ...t,
                addonFeature: feature,
                unitPrice: Number.isFinite(unit) ? unit : null,
                amount: amt,
              };
            });
        } else if (topupsData?.addons && typeof topupsData.addons === "object") {
          // e.g. { addons: { images_10:{ price_eur, bump:{images:10}}, ... } }
          normalized = Object.keys(topupsData.addons).map((id) => {
            const t = topupsData.addons[id] || {};
            const feature = inferAddonFeature({ id, bump: t.bump });
            const unit = inferUnitPrice({ id, ...t, label: t.label || "" });
            const amt = inferAddonAmount({ id, ...t }, feature);

            return {
              id,
              type: "addon",
              bump: t.bump,
              label: t.label,
              addonFeature: feature,
              unitPrice: Number.isFinite(unit) ? unit : null,
              amount: amt,
            };
          });
        } else if (
          topupsData?.data?.addons &&
          typeof topupsData.data.addons === "object"
        ) {
          normalized = Object.keys(topupsData.data.addons).map((id) => {
            const t = topupsData.data.addons[id] || {};
            const feature = inferAddonFeature({ id, bump: t.bump });
            const unit = inferUnitPrice({ id, ...t, label: t.label || "" });
            const amt = inferAddonAmount({ id, ...t }, feature);

            return {
              id,
              type: "addon",
              bump: t.bump,
              label: t.label,
              addonFeature: feature,
              unitPrice: Number.isFinite(unit) ? unit : null,
              amount: amt,
            };
          });
        }

        setAddons(Array.isArray(normalized) ? normalized : []);
      } else {
        setAddons([]);
      }
    } catch (_e) {
      setPricingSource("");
      setPricingPlans(FALLBACK_LANDING_PLANS_VIEW);
      setAddons([]);
      setSignupBonus(DEFAULT_SIGNUP_BONUS);
    }
  }, []);

  // Initial load + periodic refresh
  useEffect(() => {
    let alive = true;

    const run = async () => {
      if (!alive) return;
      await loadPromo();
      if (!alive) return;
      window.requestAnimationFrame(() => measureBars());
    };

    run();

    const onFocus = () => {
      loadPromo().then(() => {
        window.requestAnimationFrame(() => measureBars());
      });
    };

    window.addEventListener("focus", onFocus);

    const interval = setInterval(() => {
      loadPromo().then(() => {
        window.requestAnimationFrame(() => measureBars());
      });
    }, 60000);

    return () => {
      alive = false;
      window.removeEventListener("focus", onFocus);
      clearInterval(interval);
    };
  }, [loadPromo, measureBars]);

  // ✅ Pricing + addons + bonus (public, unauthenticated) — single source of truth
  useEffect(() => {
    let alive = true;

    const run = async () => {
      if (!alive) return;
      await loadPricingAndAddons();
    };

    run();

    const onFocus = () => {
      loadPricingAndAddons();
    };

    window.addEventListener("focus", onFocus);

    return () => {
      alive = false;
      window.removeEventListener("focus", onFocus);
    };
  }, [loadPricingAndAddons]);

  // keep it updated on resize + dynamic height changes
  useEffect(() => {
    const raf = window.requestAnimationFrame(() => measureBars());

    const onResize = () => measureBars();
    window.addEventListener("resize", onResize);

    let ro;
    if (typeof window !== "undefined" && "ResizeObserver" in window) {
      ro = new ResizeObserver(() => measureBars());
      if (headerRef.current) ro.observe(headerRef.current);
      if (promoRef.current) ro.observe(promoRef.current);
    }

    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
      if (ro) ro.disconnect();
    };
  }, [measureBars]);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const headerOffset = (promoHeight || 0) + (headerHeight || 0) + 12;
    const rect = el.getBoundingClientRect();
    const offsetTop = rect.top + window.scrollY - headerOffset;
    window.scrollTo({ top: offsetTop, behavior: "smooth" });
  }, [headerHeight, promoHeight]);

  const handleFaqToggle = (idx) => {
    setOpenFaqIndex((current) => (current === idx ? -1 : idx));
  };

  const promoHeadline = promo?.headline ?? "";
  const promoSubtext = promo?.subtext ?? "";
  const hasPromoText = Boolean(promoHeadline) || Boolean(promoSubtext);


  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        background: PAGE_GRADIENT,
        paddingTop: promoHeight,
      }}
    >
      {/* PROMO STRIP (fixed, non-dismissible) — DB backed */}
      {promo?.enabled && (
        <div
          ref={promoRef}
          className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#F3123C] via-[#FC2783] to-[#605DFF] text-white text-xs sm:text-sm"
        >
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 px-4 py-2">
            {hasPromoText && (
              <span className="text-center sm:text-left">
                {promoHeadline ? (
                  <span className="font-semibold">{promoHeadline}</span>
                ) : null}
                {promoSubtext ? (
                  <span className={promoHeadline ? "ml-1" : ""}>
                    {promoSubtext}
                  </span>
                ) : null}
              </span>
            )}

            {Array.isArray(promo?.links) && promo.links.length > 0 && (
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
                {promo.links.map((l) => {
                  const key = `${l.label}-${l.href}`;
                  const target = l.newTab ? "_blank" : undefined;
                  const rel = l.newTab ? "noreferrer noopener" : undefined;

                  return (
                    <a
                      key={key}
                      href={l.href}
                      target={target}
                      rel={rel}
                      className="inline-flex items-center gap-1 text-white/95 hover:text-white underline underline-offset-4 decoration-white/60 hover:decoration-white transition"
                    >
                      <span className="font-semibold">{l.label}</span>
                      {l.newTab && (
                        <ExternalLink className="h-3.5 w-3.5 opacity-90" />
                      )}
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}

      {/* HEADER */}
      <header
        ref={headerRef}
        className="sticky z-40 border-b border-white/10 bg-black/60 backdrop-blur"
        style={{ top: promoHeight }}
      >
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-2">
          {/* Logo / brand */}
          <button
            type="button"
            onClick={() => scrollToId("login-section")}
            className="flex items-center"
          >
            <img
              src="https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302079/logo_ms6cvf.png"
              alt="PixelAds logo"
              className="w-24 md:w-28 lg:w-32 xl:w-36 h-auto select-none"
              loading="eager"
              decoding="async"
            onError={useLoginAvatarFallback}
            />
          </button>

          {/* DESKTOP NAV */}
          <nav className="hidden md:flex items-center gap-6 text-sm text-slate-100">
            <button
              type="button"
              onClick={() => scrollToId("how-it-works")}
              className="hover:text-pink-300 transition-colors"
            >
              How it works
            </button>

            {/* Features dropdown with lightweight, static previews */}
            <FeaturesDropdown onSelectFeature={scrollToId} />

            {/* ✅ Correct order: Reviews before Pricing */}
            <button
              type="button"
              onClick={() => scrollToId("reviews")}
              className="hover:text-pink-300 transition-colors"
            >
              Reviews
            </button>

            <button
              type="button"
              onClick={() => scrollToId("pricing")}
              className="hover:text-pink-300 transition-colors"
            >
              Pricing
            </button>

            <button
              type="button"
              onClick={() => scrollToId("faq")}
              className="hover:text-pink-300 transition-colors"
            >
              FAQ
            </button>
          </nav>

          {/* RIGHT SIDE CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login"
              className="text-xs sm:text-sm text-slate-100 hover:text-pink-300"
            >
              Log in
            </Link>
            <Link
              to="/signup"
              className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#605DFF] to-[#A855F7] px-4 py-2 text-xs sm:text-sm font-semibold text-white shadow-[0_14px_32px_rgba(96,93,255,0.5)] hover:brightness-105 hover:-translate-y-[1px] transition"
            >
              Create a video free
            </Link>
          </div>

          {/* MOBILE right side – simplified */}
          <div className="md:hidden flex items-center gap-2">
            <Link
              to="/signup"
              className="inline-flex items-center justify-center rounded-lg bg-pink-500 px-3 py-1.5 text-xs font-semibold text-white"
            >
              Start free
            </Link>
          </div>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className="flex-1 w-full">
        {/* HERO — video first, product promise visible above the fold */}
        <section
          id="login-section"
          className="px-4 pt-8 sm:pt-10 pb-10 flex items-center justify-center"
        >
          <div className="w-full max-w-6xl mx-auto">
            <div className="mx-auto max-w-6xl">
              <div className="flex flex-col items-center text-center text-slate-50">
                <SocialProofBar />

                <h1
                  className="mt-6 text-[38px] sm:text-[50px] lg:text-[54px] font-extrabold tracking-tight leading-[1.07]"
                  style={{
                    fontFamily:
                      '"Plus Jakarta Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  }}
                >
                  <span className="block text-transparent bg-clip-text bg-gradient-to-b from-white from-[30%] to-[#b2b2b2]">
                    Turn your product page into video ads
                  </span>
                  <span className="block mt-2 text-white">
                    that stop the scroll and{" "}
                    <span className="relative inline-block">
                      <span className="text-white">sell your product</span>
                      <span className="absolute -bottom-1 left-0 right-0 h-[4px] rounded-full bg-[#F82E88]" />
                    </span>
                  </span>
                </h1>

                <p className="mx-auto mt-5 max-w-3xl text-base leading-7 text-slate-200 sm:text-lg">
                  Paste a product URL or upload a photo. Generate persuasive UGC-style ads
                  with AI avatars that hold and present your product, product demos, and
                  offer-driven explainers with voiceovers and subtitles — ready for paid campaigns,
                  without creators, filming, or video editing.
                </p>

                <div className="mt-7 flex w-full flex-col items-center gap-3">
                  <Link
                    to="/signup"
                    className="inline-flex w-full items-center justify-center rounded-xl bg-[#F82E88] px-7 py-3.5 text-sm font-semibold text-white shadow-[0_16px_40px_rgba(248,46,136,0.55)] transition hover:-translate-y-[1px] hover:brightness-110 sm:w-auto"
                  >
                    Start creating video ads free
                  </Link>
                  <p className="text-xs font-medium text-slate-300 sm:text-sm">
                    No credit card required
                  </p>
                  <p className="text-xs text-slate-400 sm:text-sm">
                    Works with Shopify, WooCommerce, Amazon, Etsy and more
                  </p>
                </div>

                <div className="mt-8 grid w-full items-stretch gap-5 lg:grid-cols-[1fr_400px]">
                  <SignupBonusCard
                    signupBonus={signupBonus}
                    className="h-full w-full"
                    showLovedBy
                    ctaLabel="Generate my free avatar video ad"
                  />

                  <div className="relative h-full w-full max-w-[400px] justify-self-center lg:justify-self-end">
                    <div className="absolute -inset-8 rounded-full bg-pink-500/15 blur-3xl" />
                    <div className="relative flex h-full flex-col rounded-[28px] border border-pink-500/30 bg-[#090918] p-3 sm:p-4 shadow-[0_28px_75px_rgba(0,0,0,0.82)]">
                      <div className="mb-3 flex flex-wrap items-center justify-between gap-2 px-1">
                        <div className="flex items-center gap-2">
                          <span className="h-2.5 w-2.5 rounded-full bg-[#F82E88] shadow-[0_0_14px_rgba(248,46,136,1)]" />
                          <span className="text-xs font-semibold text-white">
                            AI avatar product demo
                          </span>
                        </div>
                        <span className="rounded-full border border-emerald-400/25 bg-emerald-400/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-emerald-200">
                          Subtitles ready
                        </span>
                      </div>

                      <FeatureMediaPreview mediaKey="productAvatarVideo" mobileProminent />

                      <div className="mt-4 flex flex-1 flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-4 text-left">
                        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-pink-300">
                          From product page to video ad
                        </p>
                        <p className="mt-2 text-sm leading-6 text-slate-200">
                          An AI avatar holds your product, delivers your key benefit, and
                          helps turn static listing assets into a social-ready ad.
                        </p>
                        <div className="mt-auto flex flex-wrap gap-2 pt-3">
                          {["Product in hand", "Voiceover", "Subtitles", "9:16 ready"].map(
                            (item) => (
                              <span
                                key={item}
                                className="rounded-lg border border-white/10 bg-black/30 px-2 py-1 text-[11px] text-slate-300"
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mx-auto mt-7 grid w-full max-w-5xl gap-3 sm:grid-cols-3">
                  {[
                    "Create review-style UGC ads, product demos, and promotional video angles",
                    "Generate AI avatars that hold and naturally present your product",
                    "Export captioned videos for TikTok, Reels, Meta feeds and product pages",
                  ].map((t) => (
                    <div
                      key={t}
                      className="rounded-2xl border border-white/10 bg-black/35 px-4 py-4 text-center shadow-[0_16px_40px_rgba(0,0,0,0.55)]"
                    >
                      <div className="flex h-full flex-col items-center justify-center gap-2.5">
                        <Check className="h-4 w-4 flex-shrink-0 text-pink-400" />
                        <span className="text-sm leading-6 text-slate-200">{t}</span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-8 flex w-full flex-col items-center justify-center gap-4">
                  <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
                    <Link
                      to="/signup"
                      className="inline-flex items-center justify-center rounded-xl bg-[#F82E88] px-6 py-3 text-sm font-semibold text-white shadow-[0_16px_40px_rgba(248,46,136,0.55)] hover:brightness-110 hover:-translate-y-[1px] transition"
                    >
                      Claim my free ad video
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Integration trust card kept separate from the showcase content */}
        <IntegrationsCard />

        {/* Primary product promise: static ad and video sections before secondary tools */}
        <ConversionShowcaseSections />

        {/* Core video benefits */}
        <ImpactStats />

        {/* Real output examples restored from Landing 2 */}
        <RealOutputsShowcase />

        {/* HOW IT WORKS */}
        <section
          id="how-it-works"
          className="mt-10 w-full max-w-6xl mx-auto px-4 pb-10 text-slate-50"
        >
          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-semibold">
              From product page to ecommerce video ad in 3 steps
            </h2>
            <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-2xl mx-auto">
              One product link. Multiple sales angles. Videos ready for the placements where shoppers discover and buy.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-3">
            <div className="rounded-2xl bg-black/40 border border-white/10 p-4 sm:p-5">
              <div className="text-xs font-semibold text-pink-300">Step 1</div>
              <h3 className="mt-1 text-lg font-semibold">
                Paste your product or service page
              </h3>
              <p className="mt-2 text-sm text-slate-300">
                Add a product URL or product photo. PixelAds identifies the images, selling points, and offer your video should communicate.
              </p>
            </div>
            <div className="rounded-2xl bg-black/40 border border-white/10 p-4 sm:p-5">
              <div className="text-xs font-semibold text-pink-300">Step 2</div>
              <h3 className="mt-1 text-lg font-semibold">
                Choose your selling angle
              </h3>
              <p className="mt-2 text-sm text-slate-300">
                Pick a UGC testimonial, Product Spotlight, Problem / Solution, How-To Demo, promotion, product-avatar demo, or service explainer.
              </p>
            </div>
            <div className="rounded-2xl bg-black/40 border border-white/10 p-4 sm:p-5">
              <div className="text-xs font-semibold text-pink-300">Step 3</div>
              <h3 className="mt-1 text-lg font-semibold">
                Add avatar, subtitles, and format
              </h3>
              <p className="mt-2 text-sm text-slate-300">
                Generate your video with voiceover and captions, then use 9:16, 4:5, 1:1 or 16:9 versions for ads, social posts, and product pages.
              </p>
            </div>
          </div>
        </section>

        {/* FEATURES SECTION – testimonial moved above heading */}
        <section
          id="features"
          className="mt-2 w-full max-w-6xl mx-auto px-4 pb-10 text-slate-50"
        >
          <div className="mb-8 w-full">
            <div className="max-w-3xl mx-auto rounded-3xl bg-white text-slate-900 px-6 sm:px-8 py-5 border border-white/70 shadow-[0_30px_80px_rgba(0,0,0,0.8)] flex flex-col sm:flex-row items-center gap-4">
              <img
                src={loginAvatar}
                alt="PixelAds user"
                className="h-16 w-16 rounded-full object-cover border border-pink-500/70 bg-[#0B0B18]"
                loading="lazy"
                decoding="async"
                onError={useLoginAvatarFallback}
              />
              <div className="text-center sm:text-left">
                <p className="text-sm sm:text-base leading-snug">
                  <span className="font-semibold">Turn product assets into sales-ready stories:</span>{" "}use AI avatars for UGC-style testimonials, product-in-hand demonstrations, clear explainers, and subtitled ads built for sound-off feeds.
                </p>
                <p className="mt-2 text-xs font-medium text-slate-500">
                  UGC testimonials • Product avatars • Problem / solution ads • Video explainers
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-semibold">
              Create conversion-focused video ads from the products you already sell
            </h2>
            <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-2xl mx-auto">
              Create UGC testimonials, product spotlights, product-holding demonstrations, problem/solution ads and avatar-led explainers with captions. Image tools remain included, but the video ad workflow is the main event.
            </p>
          </div>

          <div className="space-y-8">
            {FEATURE_CATEGORIES.map((category) => {
              const items = FEATURES.filter((f) => f.category === category);
              if (!items.length) return null;

              const isVideo = category === "Video ads";

              return (
                <div key={category} className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-base sm:text-lg font-semibold text-slate-100">
                      {category}
                    </h3>

                    {!isVideo && (
                      <div className="text-[11px] sm:text-xs text-slate-400">
                        {category === "Image ads" &&
                          "Generate scroll-stopping product visuals for feeds, Stories, carousels, and landing pages."}
                        {category === "Image cleanup & fixes" &&
                          "Fix, restore, and polish your assets so every creative looks more premium and trustworthy."}
                      </div>
                    )}
                  </div>

                  <div className="space-y-6">
                    {items.map((f) => (
                      <div key={f.id} id={f.id} className="space-y-2">
                        <h4 className="text-sm sm:text-base md:text-lg font-semibold text-white">
                          {f.title}
                        </h4>

                        <article className="group rounded-[24px] bg-[#050516]/95 border border-white/10 p-4 sm:p-6 md:p-7 shadow-[0_18px_45px_rgba(0,0,0,0.75)] transition-transform duration-150 hover:-translate-y-1 hover:border-pink-500/70 hover:shadow-[0_0_0_1px_rgba(252,39,131,0.7),0_22px_50px_rgba(0,0,0,0.85)]">
                          <div className="flex flex-col md:flex-row items-stretch gap-4 sm:gap-5 md:gap-7">
                            <div className="md:w-[44%] lg:w-[40%]">
                              <FeatureMediaPreview mediaKey={f.mediaKey} />
                            </div>

                            <div className="md:flex-1 flex flex-col justify-center">
                              <div>
                                <div className="text-xs uppercase tracking-wide text-pink-300/80">
                                  {category}
                                </div>
                              </div>

                              <p className="mt-3 text-xs sm:text-sm md:text-[0.95rem] text-slate-200">
                                {f.details || f.description}
                              </p>

                              {Array.isArray(f.bullets) &&
                                f.bullets.length > 0 && (
                                  <ul className="mt-3 space-y-1.5 text-xs sm:text-sm text-slate-300">
                                    {f.bullets.map((item) => (
                                      <li
                                        key={item}
                                        className="flex items-start gap-2"
                                      >
                                        <Check className="mt-0.5 h-4 w-4 text-pink-400 flex-shrink-0" />
                                        <span>{item}</span>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </div>
                        </article>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-10 rounded-3xl border border-white/10 bg-black/35 p-5 sm:p-7">
            <div className="max-w-3xl">
              <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
                Supporting tools included
              </p>
              <h3 className="mt-2 text-xl sm:text-2xl font-semibold text-white">
                Polish the assets behind every video campaign
              </h3>
              <p className="mt-2 text-sm text-slate-300">
                Video ads are the headline feature. When your campaign needs supporting visuals, PixelAds also prepares product images for ads, product pages, thumbnails, and landing pages.
              </p>
            </div>

            <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {FEATURES.filter((feature) => feature.category !== "Video ads").map(
                (feature) => (
                  <div
                    key={feature.id}
                    className="rounded-2xl border border-white/10 bg-white/[0.03] p-4"
                  >
                    <div className="flex items-center gap-2">
                      <span aria-hidden="true">{feature.emoji}</span>
                      <h4 className="text-sm font-semibold text-white">
                        {feature.title}
                      </h4>
                    </div>
                    <p className="mt-2 text-xs leading-5 text-slate-400">
                      {feature.description}
                    </p>
                  </div>
                )
              )}
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-3 text-sm text-slate-200 md:grid-cols-3">
            {[
              "Turn product URLs and images into video ad concepts instead of starting from scratch.",
              "Create UGC testimonials, product spotlight videos, demos, promotions, and explainers.",
              "Use AI avatars that hold and present a real product without arranging a shoot.",
              "Add subtitles for customers scrolling TikTok, Reels, Shorts, and Meta with sound off.",
              "Generate placements for vertical discovery feeds, feed ads, retargeting, and product pages.",
              "Polish the supporting images behind each video campaign with included image tools.",
            ].map((item) => (
              <div key={item} className="flex items-start gap-2">
                <Check className="mt-0.5 h-4 w-4 text-pink-400" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </section>

        {/* CTA BAND */}
        <section className="mt-2 w-full max-w-6xl mx-auto px-4 pb-10 text-slate-50">
          <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-pink-600/20 via-fuchsia-600/10 to-transparent p-6 sm:p-8">
            <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-pink-500/20 blur-3xl" />
            <div className="relative grid items-center gap-6 md:grid-cols-[1fr_auto]">
              <div>
                <h3 className="text-2xl font-bold">
                  Stop relying on static photos for every product ad
                </h3>
                <p className="mt-1 text-slate-200 text-sm sm:text-base">
                  Turn one product URL or image into UGC-style testimonials, product-holding demos, problem/solution ads, and captioned videos for the platforms where you sell.
                </p>
              </div>
              <Link
                to="/signup"
                className="inline-flex items-center gap-2 rounded-xl bg-[#FC2783] px-6 py-3 text-sm font-semibold text-white hover:bg-pink-600"
              >
                Claim my free ad video
              </Link>
            </div>
          </div>
        </section>

        {/* ✅ Reviews (moved above Pricing) */}
        <ReviewsSection />

        {/* PRICING PREVIEW */}
        <section
          id="pricing"
          className="mt-2 w-full max-w-6xl mx-auto px-4 pb-10 text-slate-50"
        >
          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-semibold">Pricing</h2>
            <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-2xl mx-auto">
              Every plan includes AI UGC-style video ads, product-holding avatars, ecommerce video angles, subtitles, and the supporting image toolkit. Pick how many creatives you need each month.
            </p>
          </div>

          {/* ✅ FREE SIGNUP BONUS (Starter bundle) */}
          <SignupBonusCard
            signupBonus={signupBonus}
            className="mb-8"
            ctaLabel="Turn my product into an ad free"
          />

          <div className="flex items-center justify-center mb-6">
            <div
              className="inline-flex items-center p-1 rounded-2xl border border-white/15"
              style={{ background: "#050516" }}
            >
              <button
                type="button"
                onClick={() => setBillingCycle("monthly")}
                className={`px-4 py-1.5 rounded-xl text-xs sm:text-sm font-semibold transition-colors ${
                  billingCycle === "monthly"
                    ? "bg-[#F82E88] text-white shadow-[0_8px_18px_rgba(248,46,136,0.5)]"
                    : "text-slate-200 hover:text-white"
                }`}
              >
                Monthly
              </button>
              <button
                type="button"
                onClick={() => setBillingCycle("yearly")}
                className={`px-4 py-1.5 rounded-xl text-xs sm:text-sm font-semibold transition-colors ${
                  billingCycle === "yearly"
                    ? "bg-[#F82E88] text-white shadow-[0_8px_18px_rgba(248,46,136,0.5)]"
                    : "text-slate-200 hover:text-white"
                }`}
              >
                Yearly <span className="ml-1 opacity-80">(2 months free)</span>
              </button>
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-3">
            {pricingPlans.map((plan) => {
              const id = String(plan.id || "").toLowerCase();

              let Icon = Star;
              if (id === "pro") Icon = Crown;
              if (id === "business") Icon = Zap;

              const isMostUsed = Boolean(plan.mostUsed) || id === "pro";

              return (
                <div
                  key={plan.id}
                  className="relative rounded-3xl border p-5 sm:p-6 bg-[#111124]/95 text-slate-50 shadow-[0_14px_30px_rgba(0,0,0,0.55)]"
                  style={
                    isMostUsed
                      ? {
                          borderColor: ACCENT,
                          boxShadow:
                            "0 0 0 1px rgba(248,46,136,0.5),0 18px 36px rgba(0,0,0,0.7)",
                        }
                      : {}
                  }
                >
                  {isMostUsed && (
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 flex flex-col items-center">
                      <span className="px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-[0.12em] bg-[rgba(248,46,136,1)] text-[#050514] shadow-[0_8px_22px_rgba(248,46,136,0.6)]">
                        Most used
                      </span>
                      <span
                        className="mt-2 h-[3px] w-40 rounded-full"
                        style={{
                          background:
                            "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(248,46,136,1) 45%, rgba(0,0,0,0) 100%)",
                          boxShadow: "0 0 18px rgba(248,46,136,0.6)",
                        }}
                      />
                    </div>
                  )}

                  <div className="flex items-center justify-center gap-2 pt-2">
                    <Icon className="w-5 h-5 text-white/90" />
                    <h3 className="text-xl font-bold tracking-tight">{plan.name}</h3>
                  </div>


                  <div className="mt-5 text-center">
                    {(() => {
                      const displayedPrice =
                        billingCycle === "yearly"
                          ? plan.yearlyPricePerMonth
                          : plan.monthlyPrice;
                      const crossedOutPrice = upliftMonthlyAnchor(displayedPrice);

                      return billingCycle === "yearly" ? (
                        <>
                          <div className="flex items-center justify-center gap-2 text-sm font-semibold">
                            {crossedOutPrice ? (
                              <span className="line-through text-[#F97373] text-lg sm:text-xl font-extrabold">
                                {crossedOutPrice}/month
                              </span>
                            ) : null}
                            <span className="inline-flex items-center rounded-full border border-emerald-500/70 bg-emerald-500/15 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-emerald-200">
                              2 months free
                            </span>
                          </div>
                          <div className="mt-2 text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
                            {plan.yearlyPricePerMonth}
                            <span className="text-base font-semibold"> /month</span>
                          </div>
                          <div className="mt-1 text-xs sm:text-sm text-slate-300">
                            {plan.yearlyBilled}
                          </div>
                        </>
                      ) : (
                        <>
                          {crossedOutPrice ? (
                            <div className="text-lg sm:text-xl font-extrabold text-[#F97373] line-through">
                              {crossedOutPrice}/month
                            </div>
                          ) : null}
                          <div className="mt-2 text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
                            {plan.monthlyPrice}
                            <span className="text-base font-semibold"> /month</span>
                          </div>
                          <div className="mt-1 text-xs sm:text-sm text-slate-300">
                            Billed monthly • cancel anytime
                          </div>
                        </>
                      );
                    })()}
                  </div>

                  <div className="mt-6">
                    <div className="text-[11px] uppercase tracking-[0.16em] text-center text-slate-400">
                      Capacity at a glance
                    </div>

                    <div className="mt-3 grid grid-cols-3 gap-2">
                      <div className="flex flex-col items-center">
                        <ImageIcon className="w-5 h-5 text-slate-100" />
                        <span className="mt-1 text-xs sm:text-sm text-slate-200">
                          AI Images
                        </span>
                        <div className="mt-2 rounded-2xl px-3 py-3 w-full border border-white/10 bg-[#0F0F21] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] flex items-center justify-center">
                          <span className="text-3xl font-extrabold text-white">
                            {plan.imagesPerMonth}
                          </span>
                        </div>
                        <span className="mt-1 text-[11px] text-slate-500">
                          per month
                        </span>
                      </div>

                      <div className="flex flex-col items-center">
                        <Film className="w-5 h-5 text-slate-100" />
                        <span className="mt-1 text-xs sm:text-sm text-slate-200">
                          AI Videos
                        </span>
                        <div
                          className="mt-2 rounded-2xl px-3 py-3 w-full border flex items-center justify-center"
                          style={{
                            background:
                              "linear-gradient(180deg, rgba(248,46,136,0.10) 0%, rgba(20,20,40,0.9) 100%)",
                            borderColor: "rgba(248,46,136,0.55)",
                            boxShadow: "0 0 0 1px rgba(248,46,136,0.2) inset",
                          }}
                        >
                          <span className="text-3xl font-extrabold text-white">
                            {plan.videosPerMonth}
                          </span>
                        </div>
                        <span className="mt-1 text-[11px] text-slate-500">
                          per month
                        </span>
                      </div>

                      <div className="flex flex-col items-center">
                        <LinkIcon className="w-5 h-5 text-slate-100" />
                        <span className="mt-1 text-xs sm:text-sm text-slate-200">
                          Pages
                        </span>
                        <div className="mt-2 rounded-2xl px-3 py-3 w-full border border-white/10 bg-[#0F0F21] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] flex items-center justify-center">
                          <span className="text-3xl font-extrabold text-white">
                            {plan.pagesPerMonth}
                          </span>
                        </div>
                        <span className="mt-1 text-[11px] text-slate-500">
                          per month
                        </span>
                      </div>
                    </div>
                  </div>

                  <Link
                    to="/signup"
                    className="mt-5 inline-flex items-center justify-center rounded-xl bg-[#22c55e] px-4 py-2.5 text-xs sm:text-sm font-semibold text-black hover:brightness-110 hover:-translate-y-[1px] transition shadow-[0_10px_24px_rgba(34,197,94,0.45)] w-full"
                  >
                    Start free with {plan.name}
                  </Link>

                  <div className="mt-3 text-[11px] text-slate-400 text-center">
                    Powered by Stripe • cancel anytime
                  </div>
                </div>
              );
            })}
          </div>

          <DailyDealCountdown />

          <div className="mt-8 rounded-3xl border border-white/10 bg-[#111124] px-5 sm:px-8 py-6 sm:py-8 shadow-[0_20px_60px_rgba(0,0,0,0.75)]">
            <div className="text-center">
              <h3 className="text-xl sm:text-2xl font-semibold text-white">
                Everything in every plan
              </h3>
              <p className="mt-2 text-sm text-slate-300 max-w-2xl mx-auto">
                No feature gating. Every plan includes the video-first toolkit: AI UGC ads, product-holding avatars, ecommerce video formats, subtitles, and supporting product visuals.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              {EVERYTHING_PLAN_COLUMNS.map((col, idx) => (
                // eslint-disable-next-line react/no-array-index-key
                <ul key={idx} className="space-y-2 text-sm text-slate-100">
                  {col.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <Check className="mt-0.5 h-4 w-4 text-emerald-400" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              ))}
            </div>

            <div className="mt-6 flex justify-center">
              <Link
                to="/signup"
                className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#605DFF] to-[#A855F7] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_14px_32px_rgba(96,93,255,0.5)] hover:brightness-105 hover:-translate-y-[1px] transition"
              >
                Start free and create ad videos
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section
          id="faq"
          className="mt-2 w-full max-w-6xl mx-auto px-4 pb-14 text-slate-50"
        >
          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-semibold">FAQ</h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {FAQ_ITEMS.map((item, idx) => {
              const open = openFaqIndex === idx;
              return (
                <div
                  key={item.q}
                  className="rounded-2xl bg-black/40 border border-white/10"
                >
                  <button
                    type="button"
                    onClick={() => handleFaqToggle(idx)}
                    className="w-full flex items-center justify-between gap-3 px-4 py-3 sm:px-5 sm:py-4"
                  >
                    <span className="text-sm sm:text-base font-medium text-slate-50 text-left">
                      {item.q}
                    </span>
                    {open ? (
                      <ChevronUp className="h-4 w-4 text-slate-200" />
                    ) : (
                      <ChevronDown className="h-4 w-4 text-slate-200" />
                    )}
                  </button>
                  {open && (
                    <div className="px-4 pb-4 sm:px-5 sm:pb-5 pt-0">
                      <p className="text-xs sm:text-sm text-slate-300">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-slate-200 mb-3">
              Turn a real product page or product image into your first AI avatar video ad before
              paying anything.
            </p>
            <Link
              to="/signup"
              className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#605DFF] to-[#A855F7] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_14px_32px_rgba(96,93,255,0.5)] hover:brightness-105 hover:-translate-y-[1px] transition"
            >
              Start free – no card required
            </Link>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="border-t border-white/10 bg-[#111124]">
        <div className="max-w-6xl mx-auto px-4 py-8">
          <div className="grid gap-8 md:grid-cols-[1.2fr,1fr,1fr,1fr] text-xs sm:text-sm text-slate-300">
            <div>
              <button
                type="button"
                onClick={() => scrollToId("login-section")}
                className="inline-flex items-center gap-2"
              >
                <img
                  src="https://res.cloudinary.com/dxggxu3qn/image/upload/v1779302079/logo_ms6cvf.png"
                  alt="PixelAds logo"
                  className="w-24 md:w-28 lg:w-32 xl:w-36 h-auto select-none"
                  loading="lazy"
                  decoding="async"
                onError={useLoginAvatarFallback}
                />
              </button>
              <p className="mt-3 max-w-xs text-slate-400">
                Turn product pages and images into UGC-style video ads,
                product-holding avatar demos, and subtitle-ready explainers.
              </p>
              <p className="mt-2 text-[11px] text-slate-500">
                © {new Date().getFullYear()} PixelAds.ai. All rights reserved.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-slate-100 mb-2 text-sm">
                Features
              </h3>
              <div className="flex flex-col gap-1.5">
                {FEATURES.slice(0, 7).map((feature) => (
                  <button
                    key={feature.id}
                    type="button"
                    onClick={() => scrollToId(feature.id)}
                    className="text-left text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                  >
                    {feature.title}
                  </button>
                ))}
                {FEATURES.length > 7 && (
                  <button
                    type="button"
                    onClick={() => scrollToId("features")}
                    className="text-left text-xs sm:text-sm text-slate-400 hover:text-pink-300 transition-colors"
                  >
                    View all features
                  </button>
                )}
              </div>
            </div>

            <div>
              <h3 className="font-semibold text-slate-100 mb-2 text-sm">
                Company &amp; legal
              </h3>
              <div className="flex flex-col gap-1.5">
                <button
                  type="button"
                  onClick={() => scrollToId("how-it-works")}
                  className="text-left text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  How it works
                </button>
                <button
                  type="button"
                  onClick={() => scrollToId("pricing")}
                  className="text-left text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  Pricing
                </button>
                <Link
                  to="/privacy"
                  className="text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  className="text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  Terms &amp; Conditions
                </Link>
                <Link
                  to="/refund-policy"
                  className="text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  Refund Policy
                </Link>
              </div>
            </div>

            <div>
              <h3 className="font-semibold text-slate-100 mb-2 text-sm">
                Support
              </h3>
              <div className="flex flex-col gap-1.5">
                <a
                  href="mailto:pixeladsai@gmail.com"
                  className="text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  Contact support
                </a>
                <button
                  type="button"
                  onClick={() => scrollToId("faq")}
                  className="text-left text-xs sm:text-sm text-slate-300 hover:text-pink-300 transition-colors"
                >
                  FAQ
                </button>
              </div>
            </div>
          </div>

          {/* keep addons + source state "used" to avoid unused-var lint if you later render it here */}
          {/* eslint-disable-next-line no-unused-vars */}
          <div className="hidden">
            {addons?.length || 0} | {pricingSource || ""}
          </div>
        </div>
      </footer>
    </div>
  );
}
